import commonCountryEn from './common/country/default';
import commonCurrencyEn from './common/currency/default';
import { commonDateEn } from './common/date/default';
import componentsComboboxEn from './components/combobox/default';
import componentsDataTableEn from './components/data-table/default';
import componentsFlowNodeEn from './components/flow-node/default';
import componentsFormAddressFormEn from './components/form/address-form/default';
import { componentsFormFileItemEn } from './components/form/file-item/default';
import componentsSchedulePickerEn from './components/schedule-picker/default';
import { componentsUploadEn } from './components/upload/default';
import pagesContractorCoreEn from './contractor-core';
import domainAppUserEn from './features/app-user/default';
import boeTaskEn from './features/boe-task/default';
import cFormEn from './features/c-form/default';
import contractAndCostEn from './features/contract-and-cost/default';
import featuresDeviceGroupEn from './features/device-group/default';
import domainDeviceEn from './features/device/default';
import formFactoryEn from './features/form-factory/default';
import operationArchivesEn from './features/operation-archives/default';
import operationPackageConfigEn from './features/operation-package-config/default';
import operationPackageInstanceEn from './features/operation-package-instance/default';
import operationPackageEn from './features/operation-package/default';
import domainPersonEn from './features/person/default';
import domainQrScannerEn from './features/qr-scanner/default';
import ruleAndPolicyEn from './features/rule-and-policy/default';
import shortcutsEn from './features/shortcuts/default';
import ssoEn from './features/sso/default';
import domainWorkerTypeRuleEn from './features/worker-type-rule/default';
import pagesGAOperationCoreEn from './ga-operation-core';
import individualPagesEn from './individual-pages';
import pagesLaborCoreEn from './labor-core';
import pagesAccessesEn from './pages/accesses/default';
import pagesAppsOrgSettingsEn from './pages/apps/org-settings/default';
import { pagesAttendanceCoreEn } from './pages/attendance-core/attendanceCore';
import { pagesAttendanceEngineEn } from './pages/attendance-engine/attendanceEngine';
import { pagesAttendancesEn } from './pages/attendances/attendances';
import pagesAuthEn from './pages/auth/default';
import pagesOperationEventsEn from './pages/business-operation-events/default';
import pagesBusinessPartnerEn from './pages/business-partner/default';
import pagesCertificationEn from './pages/certification/default';
import pagesCockpitEn from './pages/cockpit/default';
import { pagesContractEn } from './pages/contract/contract';
import { pagesContractListEn } from './pages/contract/list';
import pagesContractingCorporationProfileEn from './pages/contracting-corporation-profile/default';
import pagesCustomerLedgerEn from './pages/customer-ledger/default';
import pagesDataConnectorEn from './pages/data-connector/default';
import pagesDealLedgerEn from './pages/deal-ledger/default';
import pagesDeviceProfileMdmEn from './pages/device/profile/mdm/default';
import pagesDeviceCatalogAddEn from './pages/deviceCatalog/add/default';
import pagesDevicesAddEn from './pages/devices/add/default';
import { pagesDevicesAlertsEn } from './pages/devices/alerts/default';
import { pagesDevicesCatalogEn } from './pages/devices/catalog/default';
import { pagesDevicesContractAndCostEn } from './pages/devices/contract-and-cost/default';
import { pagesDevicesDeviceGroupsEn } from './pages/devices/device-groups/default';
import pagesDevicesExternalItSaasEn from './pages/devices/external-it-saas/default';
import pagesDevicesFileEn from './pages/devices/file/default';
import { pagesDevicesRuleAndPolicyEn } from './pages/devices/rule-and-policy/default';
import { pagesEquipmentEn } from './pages/equipment/equipment';
import { pagesFleetsEn } from './pages/fleets/fleet';
import { pagesIdManagementsEn } from './pages/id-managements/id-managements';
import { pagesITOperationCoreEn } from './pages/it-operation-core/default';
import pagesItemLedgerEn from './pages/item-ledger/default';
import pagesLicensesEn from './pages/licenses/default';
import pagesMarketplaceEn from './pages/marketplace/default';
import pagesNetworksEn from './pages/networks/default';
import pagesNotificationAndResponseEn from './pages/notification-and-response/default';
import pagesOauth2En from './pages/oauth2/default';
import pagesOrganizationEn from './pages/organization/default';
import { pagesPayrollCoreEn } from './pages/payroll-core/payrollCore';
import { pagesPayrollEngineEn } from './pages/payroll-engine/payrollEngine';
import { pagesPayrollEn } from './pages/payroll/payroll';
import pagesPeopleOperationActivityEn from './pages/people/operationActivity';
import pagesPeopleSettingsEn from './pages/people/settings/default';
import pagesPersonAddPersonCertificationEn from './pages/person/addPersonCertification/default';
import pagesPersonCertificationEn from './pages/person/certification/default';
import pagesPersonCsvImportEn from './pages/person/csvImport/default';
import pagesPersonExternalHrSaasEn from './pages/person/external-hr-saas/default';
import pagesPersonImportCsvEn from './pages/person/import-csv/default';
import { pagesPlacesEn } from './pages/places/places';
import pagesProfileAppIdRuleAndPolicyEn from './pages/profile/app/rule-and-policy/default';
import { pagesPublicIdsEn } from './pages/public-ids/default';
import pagesSettingsPermissionAndRolesEn from './pages/settings/permission-and-roles/default';
import pagesSettingsPersonsEn from './pages/settings/persons/default';
import pagesSettingsSettingsEn from './pages/settings/settings/default';
import pagesSoftwareEn from './pages/software/default';
import pagesStarlinksEn from './pages/starlinks/default';
import { pagesStorageFilesEn } from './pages/storage-files/default';
import pagesSupplierLedgerEn from './pages/supplier-ledger/default';
import { pagesTimeAndAttendanceEn } from './pages/time-and-attendance/timeAndAttendance';
import pagesUsersEn from './pages/users/default';
import pagesVendorMarketplaceEn from './pages/vendor/marketplace/default';
import { pagesWorkScheduleEn } from './pages/work-schedule/workSchedule';
const en = {
  common: {
    action: {
      add: 'Add',
      apply: 'Apply',
      approve: 'Approve',
      back: 'Back',
      cancel: 'Cancel',
      clear: 'Clear',
      close: 'Close',
      collapse: 'Collapse',
      complete: 'Complete',
      continue: 'Continue',
      copy: 'Copy',
      create: 'Create',
      deactivate: 'Deactivate',
      delete: 'Delete',
      duplicate: 'Duplicate',
      edit: 'Edit',
      editAction: 'Edit',
      expand: 'Expand',
      export: 'Export',
      more: 'More actions',
      next: 'Next',
      permanentlyDelete: 'Permanently Delete',
      reactivate: 'Reactivate',
      reject: 'Reject',
      remand: 'Remand',
      save: 'Save',
      saving: 'Saving...',
      submit: 'Submit',
      unassign: 'Unassign',
      update: 'Update'
    },
    anchorDate: 'Anchor Date',
    avatarUploadFailed: 'Avatar upload failed',
    avatarUploadSuccess: 'Avatar uploaded successfully',
    bloodRhFactor: {
      NEGATIVE: '-',
      POSITIVE: '+',
      UNKNOWN: ''
    },
    bloodType: {
      A: 'A',
      AB: 'AB',
      B: 'B',
      O: 'O',
      UNKNOWN: 'Unknown'
    },
    brand: 'DRESS CODE',
    breadcrumbs: {
      addAssignmentRule: 'Add Assignment Rule',
      addCatalog: 'Add Catalog',
      addDevice: 'Add Device',
      alumni: 'Alumni',
      apps: 'Software',
      businessPartners: 'Business Partners',
      catalog: 'Catalog',
      categoryPermissions: 'Category Permissions',
      certifications: 'Certifications',
      contracts: 'Contracts',
      customers: 'Customers',
      dealList: 'Deal List',
      deviceCatalogs: 'Device Catalogs',
      devices: 'Devices',
      equipment: 'Equipment',
      files: 'Files',
      folders: 'Folders',
      groupId: 'Group ID',
      handlingCertifications: 'Handling Certifications',
      home: 'Home',
      idManagement: 'IDs',
      integrations: 'Integrations',
      inventory: 'Inventory',
      issues: 'Issues',
      itemLedger: 'Item Ledger',
      licenseDetail: 'License Detail',
      licenses: 'Licenses',
      orders: 'Orders',
      peopleGroups: 'People Groups',
      permissionAndRoles: 'Permission & Roles',
      personProfile: 'Profile',
      places: 'Places',
      prcForce: 'PRC Force',
      productPermissions: 'Product Permissions',
      registry: 'Registry',
      roles: 'Roles',
      ruleAndPolicy: 'Rule & Policy',
      servicePlan: 'Service Plan',
      servicePlanDetail: 'Service Plan Detail',
      settings: 'Settings',
      software: 'Software',
      specialtyCertifications: 'Specialty Certifications',
      storageFiles: 'Storage Files',
      supplierLedger: 'Suppliers',
      suppliers: 'Suppliers',
      userAccounts: 'User Accounts & Auth',
      workforce: 'Workforce'
    },
    comparison: {
      lessThan: 'less than',
      moreThan: 'more than',
      orLess: 'or less',
      orMore: 'or more',
      under: 'under'
    },
    confirm: 'Confirm',
    contactPreference: {
      EMAIL: 'Email',
      PHONE: 'Phone Number'
    },
    contractCategory: {
      DEVICE: 'Device',
      FACILITY: 'Facility',
      HUMAN_RESOURCE: 'Human Resource',
      OTHER: 'Other',
      SERVICE: 'Service'
    },
    contractStatus: {
      CANCELLED: 'Cancelled',
      DRAFT: 'Draft',
      EXECUTED: 'Executed',
      PENDING_SIGNATURE: 'Pending Signature',
      REJECTED_SIGNATURE: 'Rejected Signature',
      TERMINATED: 'Terminated',
      WAITING: 'Waiting'
    },
    contractType: {
      EMPLOYMENT: 'Employment',
      LEASE: 'Lease',
      OFFICE_RENTAL: 'Office Rental',
      OTHER: 'Other',
      PURCHASE: 'Purchase',
      SAAS_SUBSCRIPTION: 'SaaS Subscription',
      SERVICE: 'Service'
    },
    copied: 'Copied to clipboard',
    copyFailed: 'Failed to copy',
    // TODO: Typecheckにてテンプレートリテラル型の組み合わせ爆発を防ぐため、i18next の ParseKeys が literal union を展開しないよう型を widening する。
    // どこかで根本解決した方が良い気がする。
    country: commonCountryEn as Record<string, string>,
    currency: commonCurrencyEn as Record<string, string>,
    current: 'Current',
    date: commonDateEn,
    dateOfBirth: 'Date of birth',
    detail: 'Detail',
    deviceType: {
      computer: 'Computer',
      mobile: 'Mobile',
      monitor: 'Monitor',
      other: 'Other',
      server: 'Server'
    },
    email: 'Email',
    emailMismatch: {
      label: 'Email mismatch'
    },
    enDash: '–',
    extensionNumber: 'Extension Number',
    fileItem: componentsFormFileItemEn,
    gender: {
      FEMALE: 'Female',
      MALE: 'Male',
      UNKNOWN: 'Unknown'
    },
    hasNoValue: 'No',
    hasValue: 'Yes',
    left: 'left',
    list: {
      account: 'Account',
      alerts: 'Alerts',
      alumni: 'Alumni',
      apps: 'Software',
      assignment: 'Assignment',
      businessPartners: 'Business Partners',
      certifications: 'Certifications',
      community: 'Community',
      configuration: 'Rule & Policy',
      contractAndCost: 'Contract & Cost',
      contracts: 'Inventory',
      control: 'Control',
      customers: 'Customers',
      devices: 'Devices',
      educationAndQualification: 'Educ. & Qual.',
      enhancements: 'Enhancements',
      equipment: 'Inventory',
      files: 'Files',
      groupId: 'Group ID',
      groups: 'Groups',
      history: 'History',
      idLists: 'Individual ID',
      integrations: 'Integrations',
      inventory: 'Inventory',
      items: 'Items',
      job: 'Job',
      laborCore: 'Labor Core',
      library: 'Library',
      license: 'Licenses',
      licenses: {
        inventory: 'Inventory'
      },
      lifecycle: 'Lifecycle',
      list: 'List',
      marketplace: 'Marketplace',
      mdm: 'MDM',
      monitoring: 'Monitoring',
      networks: 'Networks',
      operationActivity: 'Operation Activity',
      overview: 'Overview',
      people: 'People',
      peopleGraph: 'People Graph',
      permissionAndRoles: {
        categoryPermissions: 'Category Permissions',
        dataScopePermissions: 'Member Portal Permissions',
        help: {
          description: 'A Role is defined by a combination of People Groups and Permissions.\nA People Group defines a group of people based on specific conditions. \nPermissions define fine-grained control over access to DRESS CODE`s products, determining which content items are visible, editable, and more.',
          title: 'What is Permission & Roles?'
        },
        peopleGroups: 'People Groups',
        productPermissions: 'Product Permissions',
        roles: 'Roles'
      },
      personProfile: {
        apps: 'Software',
        certificationDetail: 'Detail',
        contractorInformation: 'Contractor Information',
        employeeInformation: 'Employee Information',
        equipment: 'Equipment',
        personalInformation: 'Personal Information',
        publicId: 'Public ID',
        workExperience: 'Work Experience'
      },
      persons: {
        individual: 'Individual Accounts',
        operator: 'Staff Accounts',
        people: 'People',
        ruleAndPolicy: 'Rule & Policy',
        settings: 'Settings'
      },
      placeAdministrators: 'Oversight Persons',
      places: 'Places',
      position: 'Position',
      prcForce: 'PRC Force',
      productVersion: 'Product Version',
      profile: 'Profile',
      profiles: 'Profiles',
      publicIds: 'Public IDs',
      registry: 'Registry',
      roadmapList: 'Roadmap List',
      ruleAndPolicy: 'Rule & Policy',
      salaryPayment: 'Salary & Payment',
      servicePlan: 'Service Plan',
      settings: 'Settings',
      software: {
        activityMonitoring: 'Activity Monitoring',
        alerts: 'Alerts',
        architecture: 'Architecture',
        contractsAndCost: 'Contracts & Cost',
        detail: 'Detail',
        rulesAndPolicy: 'Rules & Policy',
        settings: 'Settings',
        userAccounts: 'Accounts'
      },
      status: 'Status',
      store: 'Store',
      suppliers: 'Suppliers',
      system: 'Software/Hardware',
      users: 'Users',
      workforce: 'Workforce'
    },
    loading: 'Loading...',
    maritalStatus: {
      DIVORCED: 'Divorced',
      MARRIED: 'Married',
      SINGLE: 'Single',
      WIDOWER: 'Widower'
    },
    mightItBe: 'Might it be…',
    navigate: {
      goBack: 'Go back',
      home: 'Home'
    },
    noName: '(No name)',
    noOptions: 'No options',
    noResults: 'No results',
    notAnswered: 'Not answered',
    optional: 'Optional',
    phone: 'Phone',
    phoneType: {
      LANDLINE: 'Home',
      MOBILE: 'Mobile'
    },
    placeholder: {
      comingSoon: 'This page is under construction'
    },
    pleaseSelect: 'Please select',
    position: 'Position',
    primary: 'Primary',
    // TODO:以下のオブジェクトは適切な階層に移動する
    profilePopup: {
      changePassword: 'Change Password',
      signOut: 'Sign out'
    },
    readOnly: 'Read only',
    required: 'Required',
    residenceType: {
      COMPANY_HOUSING: 'Company Housing',
      OWNED: 'Owned',
      RENTED: 'Rented'
    },
    searchByName: 'Search by name',
    sex: {
      FEMALE: 'Female',
      MALE: 'Male',
      UNKNOWN: 'Unknown'
    },
    siPrefixes: {
      B: 'B',
      K: 'K',
      M: 'M'
    },
    /**
     * "ISO 4217" の通貨コードをキーにlabelを生成
     * @see https://www.iban.com/currency-codes
     */
    status: {
      assigned: 'assigned',
      available: 'available',
      disposed: 'disposed',
      hidden: 'hidden',
      maintenance: 'maintenance'
    },
    undecided: 'Undecided',
    unregistered: 'Unregistered',
    workEmailSyncStatus: {
      authWorkEmailNotSet: 'Work email not set for sign-in',
      ledgerWorkEmailNotRegistered: 'Member work email not registered'
    },
    workLocationCondition: {
      ALLOWED: 'Allowed',
      LIMITED: 'Limited',
      NOT_ALLOWED: 'Not Allowed'
    },
    workerStatus: {
      ACTIVE: 'Active',
      ALUMNI: 'Alumni',
      JOINING: 'Joining',
      ON_LEAVE: 'On leave'
    },
    workerType: {
      boardMember: 'Board Member',
      collaborator: 'Collaborator',
      contractor: 'Contractor',
      employee: 'Employee'
    }
  },
  component: {
    Combobox: componentsComboboxEn,
    ConditionEditorGrid: {
      addCondition: 'Add condition',
      and: 'And',
      copy: 'Copy',
      delete: 'Delete',
      is: 'is',
      isAnyOf: 'isAnyOf',
      moreConditions: '{{value}} more conditions',
      noFrameworkFound: 'No framework found.',
      number: 'Number',
      or: 'Or',
      select: 'Select',
      selectPlaceholder: 'Select...',
      where: 'Where'
    },
    ConfirmDialog: {
      title: '{{action}} {{resource}}'
    },
    DatePicker: {
      placeholder: 'dd/mm/yyyy'
    },
    DropZone: {
      csv: {
        dropZoneSubTitle: 'or click to upload',
        dropZoneTitle: 'Drop CSV file here'
      },
      errorTitle: 'Error',
      file: {
        dropActiveMessage: 'Drop files here',
        dropInactiveMessage: 'Drag & drop files or click to select'
      },
      image: {
        dropZoneTitle: 'Click here or drag file to upload',
        imageFileOnly: '(png, jpg)'
      }
    },
    ForbiddenApiErrorDialog: {
      goBackHomeIndividualButton: 'Go back to individual top',
      goBackHomeStaffButton: 'Go back to staff top',
      message: 'Please contact your administrator.',
      noAccessableMessage: 'You do not hold any access permissions.',
      title: 'You are not authorized to access this page.'
    },
    GlobalErrorDialog: {
      goBackButton: 'Go back',
      message: 'Sorry for the trouble.\nIf you keep having issues, contact us.',
      reSignInButton: 'Sign in again',
      title: 'Something went wrong'
    },
    IconPreviewContent: {
      goToDetail: 'View Details'
    },
    MaskedValue: {
      hide: 'Hide',
      show: 'Show'
    },
    MonthPicker: {
      placeholder: 'mm/yyyy'
    },
    NotFound: {
      backToHome: 'Back to home',
      description: "The page you're looking for doesn't exist or may have moved.",
      title: 'Not found'
    },
    Password: {
      showPassword: 'Show Password'
    },
    PersonPreviewContent: {
      goToProfile: 'Go to profile'
    },
    ServerError: {
      backToHome: 'Back to home',
      description: 'Something went wrong on our end.\nPlease try again later. If the issue persists, contact us.',
      retryButton: 'Retry',
      title: 'Server Error'
    },
    addressForm: componentsFormAddressFormEn,
    appCard: {
      goToProfile: 'Go To Profile'
    },
    appCategoryFilterChip: {
      noResult: 'No results found',
      placeholder: 'Search by category'
    },
    appIntegrationPreviewContent: {
      goToProfile: 'go to profile'
    },
    changePasswordDialog: {
      confirmPassword: 'Confirm Password',
      confirmPasswordPlaceholder: 'Confirm New Password',
      newPassword: 'New Password',
      newPasswordPlaceholder: 'New Password',
      notMatchPasswordError: 'The passwords you entered do not match.',
      oldPassword: 'Old Password',
      oldPasswordPlaceholder: 'Old Password',
      submitButton: 'Change Password',
      successfulMessage: 'Password change successful.',
      title: 'Change your password'
    },
    comingSoon: {
      close: 'Close',
      description: 'We are working diligently to bring this feature to you. Stay tuned for updates!',
      heading: 'Exciting New Feature Coming Soon!',
      summaryStatTitle: 'This Feature Coming Soon!'
    },
    contract: {
      contactPreference: 'Contact Preference',
      email: 'Email',
      name: 'Name',
      phoneNumber: 'Phone Number',
      position: 'Position',
      preferred: 'Preferred'
    },
    data: {
      unknownUser: 'Unknown User'
    },
    dataTable: {
      cells: {
        AppUserCell: {
          noName: '(No name)',
          noUser: 'No User'
        },
        AssignmentRuleCell: {
          following: 'Following',
          incorrectRole: 'Incorrect Role',
          noUser: 'No User',
          systemAccount: 'System Account',
          unknown: 'Unknown',
          violated: 'Violated'
        },
        DevicePropertyCell: {
          byod: 'BYOD',
          computer: 'Computer',
          decommissioned: 'Decommissioned',
          deleted: 'Deleted',
          faulty: 'Faulty',
          inDistribution: 'In Distribution',
          inPlaced: 'In Placed',
          inStock: 'In Stock',
          inUsed: 'In Used',
          lease: 'Lease',
          other: 'Other',
          purchase: 'Purchase',
          refurbishing: 'Refurbishing',
          rental: 'Rental',
          underRepair: 'Under Repair'
        },
        IntegratedAppsCell: {
          goToProfile: 'Go to profile',
          notSetAppName: '(Not set)',
          notSetRoleName: '(Not set)'
        },
        MultiValueCell: {
          hrPrimary: 'Primary',
          primary: 'Primary'
        },
        PersonCell: {
          noPerson: 'No Person',
          unknownPerson: '(Unknown)'
        }
      },
      columnAction: {
        hide: 'Hide',
        sortAsc: 'Asc',
        sortDesc: 'Desc'
      },
      headers: {
        MdmAppUsage: {
          appName: 'Software Name',
          lastUsed: 'Last Used',
          usageTime: 'Usage Time'
        },
        MdmOperationLog: {
          date: 'Date/Time',
          detail: 'Details',
          location: 'Location',
          type: 'Log Type'
        },
        acceptedAt: 'Accepted at',
        access7Days: '7-Day Total Access Count',
        access30Days: '30-Day Total Access Count',
        accessedTo: 'Accessed To',
        account: 'Account',
        action: 'Action',
        actions: 'Actions',
        activationDate: 'Activation Date',
        activeUser: 'Active User',
        activeUserCount: 'Active Accounts',
        address: 'Address',
        adminContact: 'Admin Manager',
        aggregateTaskCompletedAt: 'Completed At',
        aggregateTaskLatestEvent: 'Latest Event',
        aggregateTaskOperationMode: 'Operation Mode',
        aggregateTaskPipelineCount: 'Pipelines',
        aggregateTaskStartedAt: 'Started At',
        aggregateTaskTriggerMode: 'Trigger Mode',
        aiService: 'AI Service',
        alertDescription: 'Description',
        alertStatus: 'Status',
        alertTitle: 'Alert title',
        alertType: 'Alert type',
        alertUserTerminal: 'User terminal',
        anchorDate: 'Anchor Date',
        app: 'Software',
        appIntegration: 'Integration',
        appUser: 'Account',
        appUserDisplayName: 'Display Name',
        appUserLoginId: 'Login ID',
        appUserRole: 'Account Role',
        appUserStatus: 'Account Status',
        apps: 'Software',
        assetNumber: 'Asset Number',
        assetTag: 'Asset Management Number / Asset Tag',
        assignedAt: 'Assigned At',
        assignedDate: 'Assigned Date',
        assignedLicenseSubGroup: 'Expected Profile',
        assignedLocations: 'Assigned Location',
        assignedOrPlaced: 'Assigned / Placed',
        assignedPlace: 'Assigned Place',
        assignedTo: 'Assigned To',
        assignedTotal: 'Assigned / Total',
        assignedWorkLocation: 'Work location',
        assignee: 'User Name',
        assignmentDate: 'Loan Period',
        assignmentStartDate: 'Assignment Start Date',
        attendance: {
          alertListAlert: 'Alert',
          alertListSupervisor: 'Supervisor',
          approval: 'Approval',
          attendanceStatusClockingBook: 'Attendance Status',
          breakTime: 'Break Time',
          clockIn: 'Clock In',
          clockOut: 'Clock Out',
          date: 'Date',
          errorCount: 'Error Count',
          lateNightWork: 'Late-night work',
          overtimeHours: 'Overtime',
          person: 'Person',
          personClockingList: 'Employee',
          status: 'Status',
          totalHours: 'Total Hours',
          totalWorkingHoursList: 'Total hours',
          workCategoryClockingList: 'Work Category',
          workPlace: 'Work Place',
          workPlaceClockingList: 'Workplace',
          workingDays: 'Working Days'
        },
        available: 'Available',
        boardMemberType: 'Board Member Type',
        brand: 'Brand',
        browser: 'Browser',
        businessPartnerActivePeriod: 'BP Active Period',
        businessPartnerAddress: 'Address',
        businessPartnerName: 'BP Name',
        businessPartnerRegistrationDate: 'BP Registration Date',
        businessPartnerTerminationDate: 'BP Termination Date',
        businessPartnerType: 'BP Type',
        category: 'Category',
        chunkCreatedAt: 'Executed At',
        chunkId: 'ID',
        chunkProcessedAt: 'Processed At',
        chunkStatus: 'Status',
        code: 'Code',
        collaboratorType: 'Collaborator Type',
        computerType: 'Computer Type',
        confidentialityLevel: 'Confidentiality Level',
        configuredMfa: 'Configured MFA',
        connectionType: 'Connection Type',
        contractDateFrom: 'Contract start date',
        contractDateTo: 'Contract end date',
        contractEndDate: 'Contract End Date',
        contractHierarchy: 'Contract Hierarchy',
        contractNo: 'Contract No.',
        contractRenewalDate: 'Contract Renewal Date',
        contractStartDate: 'Contract Start Date',
        contractStatus: 'Contract Status',
        contractTitle: 'Contract Title',
        contractType: 'Contract Type',
        contractorType: 'Contractor Type',
        correctRole: 'Correct Role',
        createdAt: 'Created At',
        createdOn: 'Created On',
        currentApps: 'Current Software',
        currentDevices: 'Current Devices',
        custodyDate: 'Custody Period',
        custodyPlace: 'Custody Place',
        customer: 'Customer',
        dataPipelineDataType: 'Data Type',
        dataPipelineIngestionMode: 'Ingestion Mode',
        dataPipelineName: 'Pipeline Name',
        dataPipelineOperationMode: 'Operation Mode',
        dataPipelineOutputMode: 'Output Mode',
        dataPipelineSource: 'Source',
        dataPipelineTriggerMode: 'Trigger Mode',
        dcStatus: 'Status',
        deactivatedAt: 'Deactivated At',
        deactivatedOn: 'Deactivated On',
        defaultValueKind: {
          today: 'Import date'
        },
        defaultValueLabel: 'Default Value',
        deliveryDate: 'Delivery date',
        department: 'Department',
        departmentAndPositions: 'Department / Position',
        departments: 'Department',
        description: 'Description',
        destination: 'Destination',
        destinationField: 'Destination Field',
        device: 'Device',
        deviceCategory: 'Device Category',
        deviceId: 'Device ID',
        deviceMemo: 'Remarks',
        deviceModel: 'Model',
        deviceName: 'Name',
        devicePlaced: 'Installation Location Name',
        deviceStatus: 'Device Status',
        deviceTag: 'Inventory ID',
        deviceType: 'Device Type',
        devices: 'Devices',
        displayName: 'Display Name',
        displayOrder: 'Display order',
        displaySize: 'Display Size',
        disposedAt: 'Disposed At',
        disposedMemo: 'Disposed Memo',
        dormancyPattern: 'Pattern',
        dormantCount: 'Dormant Candidates',
        dormantDays: 'Dormant Days',
        dormantRate: 'Dormancy Rate',
        dresscodeUser: 'User Account',
        email: 'Email',
        employee: 'Employee',
        employeeNumber: 'Employee Number',
        employmentType: 'Employment Type',
        enabled: 'Enabled',
        endDate: 'End Date',
        endOfSupportDate: 'End of Support Date',
        environment: 'Environment',
        equipment: 'Equipment',
        equipmentAssetTag: 'Asset Management Number/Asset Tag',
        equipmentAssignedPerson: 'Assigned To',
        equipmentAssignedPlace: 'Location',
        equipmentDisposalDate: 'Disposal Date',
        equipmentFailureDate: 'Failure Date',
        equipmentFailureDescription: 'Failure Description',
        equipmentItem: 'Equipment Item',
        equipmentItemName: 'Item',
        equipmentItemType: 'Item type',
        equipmentManufacturer: 'Manufacturer',
        equipmentModel: 'Model Number',
        equipmentPlacedDate: 'Placed Date',
        equipmentPlacedLocation: 'Placed Location',
        equipmentProductName: 'Product Name',
        equipmentSerialNumber: 'Serial Number',
        equipmentStatus: 'Status',
        equipmentType: 'Equipment Type',
        expectedReturnDate: 'Expected Lending End Date',
        expiryDate: 'Expiry Date',
        familyName: 'Last Name',
        familyNamePronunciation: 'Last Name (Pronunciation)',
        fileName: 'File Name',
        fleetCategory: 'Category',
        fleetId: 'Fleet ID',
        fleetName: 'Fleet Name',
        fleetType: 'Type',
        folderName: 'Folder name',
        givenName: 'First Name',
        givenNamePronunciation: 'First Name (Pronunciation)',
        groupMemberCount: 'Members',
        hierarchyLabel: 'Hierarchy Name',
        hierarchyLevel: 'Hierarchy Level',
        hiredAt: 'Hired At',
        hrMasterCode: 'Code',
        idManagement: {
          groupAccountId: 'Group ID',
          groupTitle: 'Group ID Name',
          groupType: 'Group Type',
          ids: 'IDs',
          itService: 'IT Service',
          loginId: 'ID',
          matchType: 'ID Type',
          ownerLabel: 'Owner',
          people: 'People',
          person: 'Person',
          software: 'Software',
          workerContractType: 'Contract Type',
          workerStatus: 'Status',
          workerType: 'Worker Type'
        },
        identity: 'Identity',
        inServiceAt: 'In Service At',
        inboundAggregateDataPipelineDataType: 'Data Type',
        inboundAggregateDataPipelineName: 'Name',
        inboundAggregateDataPipelineOperationMode: 'Operation Mode',
        inboundAggregateDataPipelinePriorityCount: 'Pipeline Count',
        inboundAggregateDataPipelineTriggerMode: 'Trigger Mode',
        initialSelection: 'Initial Selection',
        installedAt: 'Installed At',
        installedDevices: 'Installed Devices',
        integrationStatus: 'Integration Status',
        invitedDate: 'Invited Date',
        ipAddress: 'IP Address',
        isBillingUser: 'Is Billing User',
        isComputer: 'Is Computer',
        isExpired: 'Is Expired',
        isFixedAsset: 'Is Fixed Asset',
        isMonitor: 'Is Monitor',
        issueAssignees: 'Assignees',
        issueDate: 'Issue Date',
        issueDetectionPath: 'Detection Path',
        issueEnvironment: 'Environment',
        issueReleaseAndTargetNodes: 'Product / Location',
        issueReportedAt: 'Reported At',
        issueReporter: 'Reporter',
        issueSeverity: 'Severity',
        issueStatus: 'Status',
        issueTitle: 'Title',
        itService: 'IT Service',
        job: 'Job',
        jobCompetency: 'Job Competency',
        jobCompetencyCode: 'Job Competency Code',
        jobType: 'Job type',
        jobTypes: 'Job type',
        joinedOn: 'Joining date',
        joiningDate: 'Start Date',
        lastAccessedAt: 'Last Accessed At',
        lastActivity: 'Latest Activity',
        lastAssignedLocations: 'Last Assigned Location',
        lastAssignmentDate: 'Last Assignment Date',
        lastBoardType: 'Last Board Type',
        lastCalculatedAt: 'Last Detection Update',
        lastCollaboratorType: 'Last Collaborator Type',
        lastContractorType: 'Last Contractor Type',
        lastDepartmentAndPositions: 'Last Department / Position',
        lastDetected: 'Last detection',
        lastEmploymentType: 'Last Employment Type',
        lastJobTypes: 'Last Job Types',
        lastPlaces: 'Last Places',
        lastSignedInAt: 'Last Signed In At',
        lastSyncedAt: 'Last sync',
        lastUpdateDate: 'Last Update Date',
        lastUpdateTime: 'Last Update Time',
        lastUpdatedAt: 'Last Updated At',
        lastUpdater: 'Last Updater',
        lastWorkforceType: 'Last Worker Type',
        leavingDate: 'Leaving Date',
        leftOn: 'Leaving date',
        leftOnDate: 'Retirement Date',
        licenseSeat: 'License Seat',
        licenseSubGroup: 'Profile',
        maintenanceReason: 'Failure Details / Symptoms',
        maintenanceStartDate: 'Failure Date',
        manufacturer: 'Manufacturer',
        mdmApp: 'MDM App',
        mdmDeviceId: 'MDM Device ID',
        memo: 'Memo',
        mfaStatus: 'MFA Status',
        middleName: 'Middle Name',
        middleNamePronunciation: 'Middle Name (Pronunciation)',
        model: 'Model Name',
        monthlyFee: 'Monthly Fee',
        name: 'Name',
        nationalIdType: 'National ID Type',
        netAmount: 'Net Amount',
        network: 'Network',
        networkType: 'Network Type',
        networks: 'Networks',
        note: 'Note',
        offboardedAt: 'Offboarded At',
        office: 'Office',
        operationActivity: 'Operation Activity',
        operationPackage: 'Operation Package',
        orderNumber: 'Order No.',
        orderedBy: 'Ordered By',
        orderedByPerson: 'Ordered by',
        organizationType: 'Organization Type',
        organizations: 'Organizations',
        osBuild: 'OS Build',
        osName: 'OS Name',
        osPlatform: 'OS Platform',
        outboundTaskArtifacts: 'Artifacts',
        outboundTaskErrorCount: 'Errors',
        outboundTaskRecordCount: 'Records',
        outboundTaskStatus: 'Status',
        overtimeHours: 'Overtime Hours',
        owner: 'Owner',
        parent: 'Parent',
        parentFolder: 'Parent Folder',
        password: 'Password',
        path: 'Path',
        payroll: {
          alertListAlert: 'Alert',
          detectedAt: 'Detected at',
          payGroup: 'Pay structure',
          period: 'Period',
          personAlertList: 'Employee'
        },
        payrollContractActual: 'Actual',
        payrollContractAttention: 'Attention',
        payrollContractFte: 'FTE',
        payrollContractHeadcount: 'Headcount',
        payrollContractHierarchyDept: 'Department',
        payrollContractOvertime: 'Overtime pay',
        payrollContractTrendSparkline: 'Trend',
        people: 'People',
        permissionHolders: 'Permission Holders',
        person: 'Person',
        personContactEmail1: 'Personal Info_Email (Primary)',
        personContactEmail2: 'Personal Info_Email (Secondary)',
        personContactPhone: 'Personal Info_Primary Phone',
        personContactPhoneCountryCode: 'Personal Info_Primary Phone (Country Code)',
        personId: 'Person ID',
        personType: 'Worker Type',
        personalContact: 'Personal Contact',
        personalOwnerName: 'Personal Owner Name',
        personalOwnerWorkerNumber: 'Personal Owner Worker Number',
        phoneNumber: 'Phone Number',
        pipelineTaskCompletedAt: 'Completed At',
        pipelineTaskIngestionMode: 'Ingestion Mode',
        pipelineTaskLatestEvent: 'Latest Event',
        pipelineTaskOperationMode: 'Operation Mode',
        pipelineTaskStartedAt: 'Started At',
        pipelineTaskTotalChunkCount: 'Total Chunks',
        pipelineTaskTriggerMode: 'Trigger Mode',
        place: 'Place',
        placeAddress: 'Address',
        placeCode: 'Place Code',
        placeContact: 'Contact',
        placeEstablishedDate: 'Established Date',
        placeName: 'Place Name',
        placeRole: 'Role',
        placeRoleIsPrimary: 'Is Primary',
        placeStatus: 'Status',
        placeWebsite: 'Website',
        placedDate: 'Installation Period',
        placement: 'Placement',
        placementDate: 'Placement Date',
        places: 'Place',
        position: 'Position',
        positions: 'Position',
        prcForce: 'PRC Force',
        previousAssignedDuration: 'Previous Assigned Duration',
        previousAssignedTo: 'Previous Assigned To',
        previousAssignee: 'Previous User Name',
        pricingModel: 'Pricing Model',
        pricingPlan: 'Pricing Plan',
        primaryWorkerEmail: 'Employee Info_Email (Primary)',
        priority: 'Priority',
        procurementDate: 'Procurement Date',
        procurementSupplier: 'Procurement Supplier',
        procurementType: 'Procurement Type',
        purchaseDate: 'Purchase Date',
        purpose: 'Usage Purpose',
        ram: 'RAM',
        rank: 'Rank',
        relatedBaseCertificationNames: 'Related Base Certification Names',
        releaseDate: 'Release Date',
        remarks: 'Remarks',
        repoUrl: 'Repo URL',
        resolutionHeight: 'Resolution (Height)',
        resolutionWidth: 'Resolution (Width)',
        responsiblePerson: 'Responsible Person',
        role: 'Role Name',
        rule: 'Rule',
        saasStatus: 'Software Status',
        secondaryWorkerEmail: 'Employee Info_Email (Secondary)',
        serialNumber: 'Serial Number',
        severtiy: 'Severity',
        sex: 'Gender',
        shadowId: 'Shadow Id',
        sim: 'SIM',
        sizeInInch: 'Size (Inch)',
        software: 'Software',
        softwareLibrary: 'Software',
        sourceField: 'Source Field',
        specialtyCategoryName: 'Specialty Category Name',
        starlinkNetworkName: 'Networks',
        starlinkPlaceId: 'Placement/Vehicle',
        starlinkServiceLineNumber: 'Service Line Name / Number',
        starlinkUserTerminalId: 'User Terminal Name / ID',
        startDate: 'Start Date',
        startingDate: 'Starting Date',
        status: 'Status',
        storage: 'Storage',
        suggestedAction: 'Suggested Action',
        supplier: 'Supplier',
        tag: 'Tag',
        targetEmail: 'Target Email',
        timestamp: 'Timestamp',
        title: 'Title',
        total: 'Total',
        totalDeductions: 'Total Deductions',
        totalEarnings: 'Total Earnings',
        totalRamMB: 'Total RAM (MB)',
        totalStorageMB: 'Total Storage (MB)',
        troubledDate: 'Troubled Date',
        uniqueUserCount: 'Unique Users',
        updated: 'Updated',
        url: 'URL',
        user: 'User Account',
        userAccount: 'User Account',
        userGroup: 'Group',
        userPlace: "User's Location Name",
        userPlaceDate: 'User Place Date',
        userWorkerName: 'User Worker Name',
        userWorkerNumber: 'User Worker Number',
        users: 'Users',
        vendor: 'Vendor',
        version: 'Version',
        warehousingDate: 'Storage Period',
        warehousingPlace: 'Storage Site Name',
        whoAccessed: 'Who Accessed',
        workLocation: 'Work Location',
        workerContractType: 'Worker Contract Type',
        workerType: 'Worker type',
        xxx: '-',
        ...componentsDataTableEn,
        organization: 'Organization'
      },
      noResult: 'No results.',
      pagination: {
        goToFirstPage: 'Go to first page',
        goToLastPage: 'Go to last page',
        goToNextPage: 'Go to next page',
        goToPreviousPage: 'Go to previous page',
        pageOrder: 'Page {{page}} of {{total}}',
        rows: '{{count}} rows',
        rowsPerPage: 'Rows per page'
      },
      placeholder: 'Search and display results',
      viewOptions: {
        toggleColumns: 'Toggle Columns'
      }
    },
    dialog: {
      form: {
        optional: '(Optional)'
      }
    },
    filterButton: {
      filter: 'Filter',
      filters: '{{val}} Filters'
    },
    filterChip: {
      confidentialityLevel: {
        confidential: 'Confidential',
        highlyConfidential: 'Highly Confidential',
        internal: 'Internal',
        label: 'Confidentiality Level',
        public: 'Public'
      },
      idType: {
        assignmentRule: 'Assignment Rule',
        employeeId: 'Employee ID',
        employeeNumber: 'Employee Number',
        employeeSubId: 'Employee Sub ID',
        label: 'ID type',
        manualAssign: 'Manual Assign',
        personalEmail: 'Personal Email',
        personalMainEmail: 'Personal Email (Primary)',
        personalPhone: 'Personal Phone',
        personalSnsId: 'Personal SNS ID',
        personalSubEmail: 'Personal Email (Secondary)',
        workerEmail: 'Work Email',
        workerMainEmail: 'Work Email (Primary)',
        workerMainPhone: 'Work Phone (Primary)',
        workerSubEmail: 'Work Email (Secondary)',
        workerSubPhone: 'Work Phone (Secondary)'
      }
    },
    filterSheet: {
      addFilter: 'Add filter',
      apply: 'Apply',
      clearAll: 'Clear all',
      title: 'Edit filter'
    },
    filterSheetButton: {
      count_one: '{{count}} Filter',
      count_other: '{{count}} Filters',
      count_zero: 'Filter'
    },
    filterTrans: {
      contains: '<sub /> <muted>contains</muted> <obj />',
      is: '<sub /> <muted>is</muted> <obj />'
    },
    flowNode: componentsFlowNodeEn,
    globalAiChat: {
      assistantTypingAriaLabel: 'Generating a reply',
      citationsLabel: 'References',
      closePanelAriaLabel: 'Close AI chat panel',
      closedStatusLabel: 'Closed',
      composerDisabledClosed: 'This chat has ended. Start a new chat.',
      composerPlaceholder: 'Ask a question or start a task...',
      createSessionErrorMessage: 'Failed to start chat',
      dismissContextAriaLabel: 'Dismiss context',
      emptyDescription: 'The AI chat helps your work with the current page context.',
      emptyTitle: 'Ask DRESS CODE AI',
      historyAction: 'History',
      historyEmpty: 'No chat history yet',
      historyGroupOlder: 'Older',
      historyGroupPast7Days: 'Past 7 days',
      historyGroupPast30Days: 'Past 30 days',
      historyGroupToday: 'Today',
      loadMoreSessionsAction: 'Load more',
      loading: 'Loading...',
      newChatAction: 'New chat',
      openButtonAriaLabel: 'Open AI chat',
      resizeHandleAriaLabel: 'Resize AI chat panel',
      retryAction: 'Retry',
      sendFailedLabel: 'Failed to send',
      sendMessageAriaLabel: 'Send message',
      sendMessageErrorMessage: 'Failed to send message',
      sendMessageServiceErrorMessage: 'The AI chat service is temporarily unavailable. Please try again later.',
      title: 'AI Chat',
      tokenUsageAriaLabel: 'AI processing amount',
      tokenUsageGuardrailBlockedInput: 'This question was not answered due to a safety check.',
      tokenUsageGuardrailBlockedOutput: 'Part of the answer was revised by a safety check.',
      tokenUsageInput: 'Read: {{formattedCount}}',
      tokenUsageIntro: 'Tokens are a rough measure of how much the AI read and wrote.',
      tokenUsageLabel: 'AI processing (reference)',
      tokenUsageOutput: 'Written: {{formattedCount}}',
      tokenUsageSafetyCheckCost: 'Safety check cost (estimate): {{amount}}',
      tokenUsageSummary: 'Processed about {{formattedTotal}} tokens in total',
      unresolvedContactSupport: 'If this does not resolve your issue, please contact your DRESS CODE representative.'
    },
    input: {
      optional: '(Optional)'
    },
    inputDay: {
      placeholder: 'Select day',
      suffix: ''
    },
    inputMonth: {
      april: '4 - April',
      august: '8 - August',
      december: '12 - December',
      february: '2 - February',
      january: '1 - January',
      july: '7 - July',
      june: '6 - June',
      march: '3 - March',
      may: '5 - May',
      november: '11 - November',
      october: '10 - October',
      placeholder: 'Select month',
      september: '9 - September'
    },
    inputPhoneNumber: {
      noResultsMessage: 'No results found',
      searchByCountryName: 'Search by country name'
    },
    inputPostalCode: {
      placeholder: ''
    },
    inputYear: {
      placeholder: 'Select year',
      suffix: ''
    },
    myAccountPopover: {
      accountSettingsButton: 'Account settings',
      developerTools: 'Developer Tools',
      helpCenter: 'Help Center',
      individual: 'Member',
      myProfile: 'My Profile',
      noMember: '(No profile)',
      operator: 'Operator',
      privacyPolicy: 'Privacy Policy',
      resetIndexedDb: 'Reset IndexedDB',
      serviceAccount: 'Service Account',
      showEnvironmentBadge: 'Show environment badge',
      signIn: 'Sign In',
      signOutButton: 'Sign out',
      switchToIndividualPage: 'Switch to member page',
      switchToOperatorPage: 'Switch to operator page',
      termOfService: 'Terms of Service'
    },
    organizationInfo: {
      locationMissing: 'If flag is missing, please re-signin.'
    },
    pagination: {
      goToFirstPage: 'Go to first page',
      goToLastPage: 'Go to last page',
      goToNextPage: 'Go to next page',
      goToPreviousPage: 'Go to previous page',
      items: '{{count}} Items',
      itemsPerPage: 'Items per page',
      pageOrder: 'Page {{page}} of {{total}}'
    },
    reorderableList: {
      moveDown: 'Move down',
      moveUp: 'Move up',
      remove: 'Remove'
    },
    richDatePicker: {
      applyButton: 'Apply',
      cancelButton: 'Cancel',
      dateInput: {
        clear: 'Clear date',
        invalidDate: 'Invalid date format',
        label: 'Date input'
      },
      display: {
        after: 'After {{date}}',
        before: 'Before {{date}}',
        over: 'Over {{date}} ago',
        range: '{{start}} to {{end}}'
      },
      placeholder: 'Select date',
      tabs: {
        custom: {
          andAllFollowingDays: 'and all following days',
          andAllPrecedingDays: 'and all preceding days',
          daysAgo7: '7 days ago',
          daysLater7: '7 days later',
          lastMonday: 'last monday',
          monthAgo1: '1 month ago',
          monthLater1: '1 month later',
          nextMonday: 'next monday',
          title: 'Custom',
          today: 'today',
          tomorrow: 'tomorrow',
          type: {
            after: 'After',
            before: 'Before',
            on: 'On',
            range: 'Between'
          },
          yesterday: 'yesterday'
        },
        presets: {
          last: 'Last',
          last2Years: 'Last 2 years',
          last3Months: 'Last 3 months',
          last3Years: 'Last 3 years',
          lastMonth: 'Last month',
          lastWeek: 'Last week',
          lastYear: 'Last year',
          over: 'Over',
          over2YearsAgo: 'Over 2 years ago',
          over3MonthsAgo: 'Over 3 months ago',
          over3YearsAgo: 'Over 3 years ago',
          overAMonthAgo: 'Over a month ago',
          overAWeekAgo: 'Over a week ago',
          overAYearAgo: 'Over a year ago',
          title: 'Presets'
        }
      },
      tooltip: {
        example: 'When 21st is today, “last week” and “over a week ago” are illustrated as follows.',
        explanation1: '“Last {X}” refers to the {X} immediately preceding the current one.',
        explanation2: '“Over {Y} ago” refers to any day before the {Y} that just ended.'
      }
    },
    selectAvatar: {
      unassigned: 'Unassigned'
    },
    selectBank: {
      clearSelection: 'Clear selection',
      fetchError: 'Failed to load bank data',
      noResultsMessage: 'No banks found',
      placeholder: 'Select bank',
      searchPlaceholder: 'Search by bank name or code'
    },
    selectBranch: {
      clearSelection: 'Clear selection',
      fetchError: 'Failed to load branch data',
      noResultsMessage: 'No branches found',
      placeholder: 'Select branch',
      searchPlaceholder: 'Search by branch name or code',
      selectBankFirst: 'Please select a bank first'
    },
    selectCountry: {
      noResultsMessage: 'No results found',
      placeholder: 'Select country',
      searchPlaceholder: 'Search by country name'
    },
    selectStateProvince: {
      noResultsMessage: 'No results found',
      placeholder: 'Select state/province',
      searchPlaceholder: 'Search by State or Province name'
    },
    shadowItAppFilterChip: {
      noResult: 'No results found',
      placeholder: 'Search by software'
    },
    sidebar: {
      accesses: 'Accesses',
      apps: 'Softwares',
      attendanceCore: 'Attendance core',
      attendanceEngine: 'Attendance Engine',
      attendances: 'Time & Attendance Book',
      bdTab: 'B&D',
      businessCentral: 'Business Central',
      businessEvent: 'Business Operation Events',
      businessPartner: 'Business Partner',
      certification: 'Certification',
      chatNavNewChat: 'New chat',
      chatNavRecent: 'Recent',
      chatNavUpcoming: 'Upcoming',
      closeSidebar: 'Close Sidebar',
      cockpit: 'Cockpit',
      cockpitMockSidebarAriaLabel: 'Cockpit sidebar',
      contract: 'Contract',
      contractingCorporationProfile: 'Contracting Corporation Profile',
      contractorCore: 'Contractor Core',
      customerLedger: 'Customers',
      dataConnector: 'Data Connector',
      dealLedger: 'Deals',
      devices: 'Devices',
      equipment: 'Equipment',
      fleet: 'Fleet',
      force: 'Force',
      gaOperationCore: 'GA Operation Core',
      icdForce: 'ICD Force',
      icdForceIncidents: 'Incidents',
      idManagement: 'IDs',
      itOperationCore: 'IT Operation Core',
      itemLedger: 'Item Ledger',
      laborCore: 'Labor Core',
      licenses: 'Licenses',
      marketplace: 'Marketplace',
      networks: 'Networks',
      neueCloseSidebar: 'Close sidebar',
      neueOpenSidebar: 'Open sidebar',
      neueSidebarAriaLabel: 'Sidebar',
      notificationAndResponse: 'Notification & Response',
      openSidebar: 'Open Sidebar',
      operationCockpit: 'Operation Cockpit',
      organization: 'Organization',
      organizationPlanning: 'Organization Planning',
      payroll: 'Payroll',
      payrollCore: 'Payroll core',
      payrollEngine: 'Payroll Engine',
      people: 'People',
      permissionAndRoles: 'Permission & Roles',
      places: 'Places',
      pnForce: 'PN Force',
      pnForceDevelopmentTickets: 'Development Tickets',
      pnForcePlanningOperationsCore: 'PN Operations Core',
      pnForceProduction: 'Production',
      ppForce: 'PP Force',
      ppForceProductPlanningCore: 'Product Planning Core',
      ppForceProductRoadmap: 'Product Roadmap',
      prcForce: 'PRC Force',
      productCentral: 'Product Central',
      productCentralCustomer: 'Customers',
      productCentralValue: 'Value',
      products: 'Products',
      publicIds: 'Public IDs',
      qaForce: 'QA Force',
      qaForceOperationsCore: 'QA Operations Core',
      qaForceTestAssets: 'Test Assets',
      qaForceTestData: 'Test Data',
      qaForceTestSets: 'Test Sets',
      qaForceTestSuites: 'Test Suites',
      settings: 'Settings',
      software: 'Softwares',
      stacktrace: 'Stacktrace',
      stacktraceIssues: 'Issues',
      stacktraceIssuesEmpty: 'No issues yet.',
      stacktraceTab: 'PVM',
      starlinks: 'Starlink',
      storageFiles: 'Storage & Files',
      supplierLedger: 'Suppliers',
      timeAndAttendance: 'Time & Attendance',
      userAccounts: 'User Accounts & Auth',
      wfmTab: 'WFM',
      workSchedules: 'Work schedules & shifts'
    },
    statusBar: {
      statusAndResourceConnector: '{{resource}} is a {{status}}'
    },
    unknownUserFilterChip: {
      exclude: 'Exclude unknown',
      include: 'Include unknown',
      noResult: 'No results found',
      only: 'Only unknown',
      placeholder: 'Search by user'
    }
  },
  components: {
    actionMemoDialog: {
      addAriaLabel: 'Add action memo',
      cancel: 'Cancel',
      delete: 'Delete',
      deleteSuccess: 'Action memo deleted successfully',
      description: 'Notes on self-report response actions, etc.',
      editAriaLabel: 'Edit action memo',
      save: 'Save',
      saveSuccess: 'Action memo saved successfully',
      saving: 'Saving...',
      title: 'Action Memo'
    },
    deviceInventoryOperationData: {
      complete: 'Complete',
      completeReview: 'Complete Review',
      reportProxyError: 'Report proxy failed',
      reportProxySuccess: 'Report proxy completed successfully',
      request: 'Request',
      requestSelfReport: 'Request Self-Report'
    },
    deviceStatusBadge: {
      bad: {
        description: 'Issues have been reported with this device',
        label: 'Bad'
      },
      count: '{{count}} devices',
      good: {
        description: 'Device is functioning normally',
        label: 'Good'
      },
      unreported: {
        description: 'Inventory report has not been submitted yet',
        label: 'Unreported'
      }
    },
    displayStatusBadge: {
      REQUEST_BEFORE: {
        description: 'Preparing request (data updating)',
        label: 'Data Updating'
      },
      REQUEST_IN_PROGRESS: {
        description: 'Executing self-report request',
        label: 'Requesting'
      },
      REVIEW_BEFORE: {
        description: 'Waiting for review (data updating)',
        label: 'Data Updating'
      },
      REVIEW_COMPLETED: {
        description: 'Review completed',
        label: 'Completed'
      },
      REVIEW_IN_PROGRESS: {
        description: 'Review in progress',
        label: 'Reviewing'
      },
      SELF_REPORT_BEFORE: {
        description: 'Waiting for self-report (data updating)',
        label: 'Data Updating'
      },
      SELF_REPORT_IN_PROGRESS: {
        description: 'Self-report in progress',
        label: 'Reporting'
      }
    },
    dock: {
      clearSelection: 'Clear selection',
      complete: 'Complete',
      itemsSelected: 'items selected',
      request: 'Request',
      requestSelfReport: 'Request self-report',
      reviewSelfReport: 'Review self-report results',
      selectAll: 'Select all',
      startReview: 'Start review'
    },
    errorDisplay: {
      defaultMessage: 'Please try again after a while',
      defaultTitle: 'Failed to load data'
    },
    errorHandling: {
      deviceNotFound: 'Device not found',
      invalidStatusTransition: 'Invalid status transition',
      inventoryInProgress: 'Inventory process is in progress',
      reportAlreadySubmitted: 'Report has already been submitted'
    },
    footerDeviceInventory: {
      instances: 'Active instances: {{count}} items',
      package: 'Package: {{name}}',
      pattern: 'Pattern: {{name}}'
    },
    modals: {
      activateCatalog: {
        cancel: 'Cancel',
        confirm: 'Activate',
        description: 'Once activated, this catalog will be available for device registration.',
        title: 'Activate Catalog?'
      }
    },
    operationDataTable: {
      dock: {
        clearSelection: 'Clear selection',
        currentPageSelected: 'Selected {{count}} items on this page.',
        itemsSelected: 'items selected',
        selectAll: 'Select all',
        selectAllPages: 'Select all {{count}} items'
      }
    },
    reportProxyDialog: {
      assignee: 'Assignee: {{name}}',
      cancel: 'Cancel',
      characterCount: '{{current}}/{{max}} characters',
      conditionBad: 'Bad - Device has issues',
      conditionGood: 'Good - Device is functioning normally',
      description: 'Submit a proxy response on behalf of the employee assigned to the device.',
      detailReason: 'Detailed reason',
      deviceCondition: 'Device Condition',
      memo: 'Memo (Optional)',
      memoPlaceholder: 'Please enter details about the device condition if any...',
      ownershipNo: 'No',
      ownershipQuestion: 'Is this device currently in your possession?',
      ownershipYes: 'Yes',
      reasonLost: 'Lost',
      reasonNotKnown: 'Not assigned or not a managed device',
      reasonOther: 'Other',
      reasonReturned: 'Already returned or collected',
      submit: 'Submit proxy report',
      submitting: 'Processing...',
      targetDevice: 'Target Device',
      title: 'Report Proxy'
    },
    reportResultBadge: {
      lost: {
        description: 'Device is lost',
        label: 'Lost'
      },
      notKnown: {
        description: 'Placement verification result is incorrect',
        label: 'Error'
      },
      other: {
        description: 'Other status',
        label: 'Other'
      },
      owned: {
        description: 'Device is properly managed',
        label: 'Legitimate'
      },
      returned: {
        description: 'Device has been returned',
        label: 'Returned'
      }
    },
    schedulePicker: componentsSchedulePickerEn,
    targetSelection: {
      nextStep: 'Next',
      selectedCount: '{{count}} selected'
    },
    upload: componentsUploadEn,
    useColumns: {
      abnormalReason: 'Abnormal Reason',
      abnormalReasonLost: 'Lost',
      abnormalReasonNotKnown: 'Wrong Person',
      abnormalReasonOther: 'Other',
      abnormalReasonReturned: 'Returned',
      actionMemo: 'Action Memo',
      actions: 'Actions',
      device: 'Device',
      deviceConditionBad: 'Bad',
      deviceConditionGood: 'Good',
      deviceConditionUnreported: 'Unreported',
      deviceTag: 'Device Tag',
      displayStatus: 'Progress Status',
      lastInventoryDate: 'Last Inventory Date',
      memo: 'Memo',
      owner: 'Owner',
      reportProxy: 'Report Proxy',
      reportType: 'Report Type',
      reportTypeAbnormal: 'Abnormal Report',
      reportTypeNormal: 'Normal',
      reportTypeUnanswered: 'Unanswered',
      reportedBy: 'Reported By',
      responsibleOwner: 'Inventory Staff',
      responsiblePerson: 'Responsible Person',
      selfReportDate: 'Self-Report Date',
      statusReport: 'Status Report',
      unassigned: 'Unassigned',
      unreported: 'Unreported',
      usageStatus: 'Usage Status',
      usageStatusConfirm: 'Confirm',
      userName: 'User'
    }
  },
  domain: {
    appUser: domainAppUserEn,
    device: domainDeviceEn,
    person: domainPersonEn,
    qrScanner: domainQrScannerEn,
    workerTypeRule: domainWorkerTypeRuleEn
  },
  features: {
    appUser: {
      status: {
        ACTIVE: 'Active',
        ARCHIVED: 'Archived',
        DEACTIVATED: 'Suspended',
        INVITED: 'Invited',
        MISSING: 'Missing'
      }
    },
    boeTask: boeTaskEn,
    cForm: cFormEn,
    contractAndCost: contractAndCostEn,
    deviceGroup: featuresDeviceGroupEn,
    formFactory: formFactoryEn,
    history: {
      emptyState: {
        description: 'Changes made after registration will appear here.',
        title: 'No change history'
      },
      error: {
        invalidDataFormat: 'Error: History data format is invalid'
      },
      floatingActionButton: {
        button: {
          text: 'Snapshot history'
        }
      },
      historyItem: {
        header: {
          button: {
            text: 'Detail'
          }
        }
      }
    },
    operationArchives: operationArchivesEn,
    operationPackage: operationPackageEn,
    operationPackageConfig: operationPackageConfigEn,
    operationPackageInstance: operationPackageInstanceEn,
    ruleAndPolicy: ruleAndPolicyEn,
    shortcuts: shortcutsEn,
    sso: ssoEn
  },
  /** どの画面でも汎用的に用いられる用語のみを定義 */
  individualPages: individualPagesEn,
  pages: {
    accesses: pagesAccessesEn,
    accountSettings: {
      cancel: 'Cancel',
      changeLanguage: 'Change language',
      changeLanguageDescription: 'After you confirm, the page will reload and display the interface in the {{target}}.',
      changeLanguageTitle: 'Changing to {{target}}',
      changePassword: 'Change Password',
      changePasswordButton: 'Change password',
      changePasswordDescription: '10 letters long with both letters and numbers and special characters (e.g. ^$*.[]{}()?"!@#%&/\\,><\':;|_~`=+-)',
      changePasswordTitle: 'Change Password',
      changingEmailNotSupported: 'Changing email is not supported yet',
      confirmDescription: 'You will be directed to the sign in page.',
      confirmNewPassword: 'Confirm New Password',
      confirmNewPasswordPlaceholder: 'Enter new password again',
      confirmSignOutButton: 'Sign out',
      confirmSignOutTitle: 'Signing out of {{accountName}}',
      currentPassword: 'Current Password',
      currentPasswordPlaceholder: 'Enter current password',
      errorInitializingPasswordChange: 'Failed to initialize password change. Please try again.',
      errorInvalidPassword: 'Password must be 10 letters long with both letters and numbers and special characters (e.g. ^$*.[]{}()?"!@#%&/\\,><\':;|_~`=+-)',
      errorPasswordNotMatch: 'Passwords do not match',
      errorRequired: 'This field is required',
      language: 'Language',
      messageChangePasswordLimitExceeded: '😅 Password change limit exceeded, please try after some time',
      messageFailedToChangePassword: '😣 Failed to change password',
      messagePasswordChangedSuccessfully: '🎉 Password changed successfully',
      messagePasswordIsIncorrect: 'Password is incorrect',
      messagePasswordIsInvalid: 'Password is invalid',
      mfa: {
        noMfaConfigured: 'No MFA methods configured',
        removeButton: 'Remove',
        removeTotpDescription: 'Are you sure you want to remove the authenticator app? You will need to set it up again to use MFA.',
        removeTotpError: 'Failed to remove authenticator app',
        removeTotpSuccess: 'Authenticator app removed successfully',
        removeTotpTitle: 'Remove Authenticator App?',
        setupTotpError: 'Failed to set up authenticator app',
        setupTotpSuccess: 'Authenticator app has been set up',
        totpDescription: 'Time-based one-time password',
        totpLabel: 'Authenticator App (TOTP)'
      },
      mfaDialogDescription: 'Check your current MFA status and configure or remove it.',
      mfaDialogTitle: 'Set up multi-factor authentication',
      mfaSettingsButton: 'Set up multi-factor authentication',
      mfaTitle: 'Multi-Factor Authentication',
      newPassword: 'New Password',
      newPasswordPlaceholder: 'Enter new password',
      password: 'Password',
      personalEmail: 'Personal email',
      showPassword: 'Show password',
      signOutButton: 'Sign out',
      sso: {
        callbackBackButton: 'Back to app',
        callbackError: 'Failed to link your SSO account. Please try again from account settings.',
        callbackLoginOk: 'SSO login is available',
        callbackLoginUnlinkHint: 'If SSO login is not needed, you can unlink from account settings.',
        callbackMultiOrgNote: '* SSO login availability may vary by organization.',
        callbackSuccess: 'Your SSO account has been linked successfully.',
        callbackTitle: 'SSO Account Linking',
        cannotUnlinkHint: 'Please set a password before unlinking SSO.',
        google: 'Google Workspace',
        helpTooltip: "SSO account linking connects your account to an external identity provider.\nTo sign in via SSO, your email domain must match the domain configured in your organization's SSO settings.",
        helpTooltipAriaLabel: 'About SSO account linking',
        initError: 'Failed to initialize SSO settings. Please try again.',
        kratosErrors: {
          '4000007': 'This identity provider account is already linked to another DRESS CODE account. Please contact your administrator.',
          '4000027': 'This identity provider account is already linked to another DRESS CODE account. Please contact your administrator.'
        },
        linkButton: 'Link',
        linkError: 'Failed to link account. Please try again.',
        linkSuccess: 'Microsoft account linked successfully',
        linked: 'Linked',
        microsoft: 'Microsoft',
        notLinked: 'Not linked',
        title: 'SSO Account Linking',
        unlinkButton: 'Unlink',
        unlinkConfirmDescription: 'Are you sure you want to unlink your {{provider}} account? You will no longer be able to sign in using {{provider}} SSO.',
        unlinkConfirmTitle: 'Unlink {{provider}} Account?',
        unlinkError: 'Failed to unlink account. Please try again.',
        unlinkOnlyMethodError: 'Cannot unlink SSO because it is your only sign-in method. Please set a password first.',
        unlinkSuccess: 'Microsoft account unlinked successfully'
      },
      title: 'Account Settings',
      workEmail: 'Work email'
    },
    apps: {
      alert: {
        actions: {
          editRole: 'Edit Role',
          openMenu: 'Open menu'
        },
        appCard: {
          goToProfile: 'Go To Profile'
        },
        filter: {
          byApp: {
            name: 'Software',
            notFound: 'No software found',
            predicate: 'is',
            searchPlaceholder: 'Search software...'
          },
          freeText: 'Filter people...',
          toggleSummary: 'Show summary'
        },
        help: {
          inactive: {
            text: 'Inactive refers to accounts that have no activity for more than 20 days. The detection of inactive accounts is only applicable to software that track last-usage timestamps.',
            title: 'Inactive?'
          },
          noUser: {
            text: 'No User lists people who should have been issued user accounts but currently do not have them.',
            title: 'No User?'
          },
          shadowIt: {
            text: 'These are access logs to software that is not connected to DRESS CODE, collected via the browser extension.<br />They are updated every hour, at the top of each hour.',
            title: 'Shadow IT?'
          },
          unidentified: {
            text: 'Unidentified refers to a user account that is not linked to any person. The account is linked by either changing the account’s email to match or assigning a person to the account',
            title: 'Unidentified?'
          },
          violatedAccountRole: {
            text: 'User accounts with roles that do not align with the assignment rule.',
            title: 'Violated Account Role?'
          },
          violatedAssignment: {
            text: 'Violated assignment refers to user accounts that exist despite not being permitted under the user assignment rules.',
            title: 'Violated Assignment?'
          }
        },
        pageTitle: 'software/alerts',
        shadowIt: {
          apps: {
            createCustomApp: 'Integrate as custom SaaS',
            freeText: 'Filter software...',
            integrate: 'Integrate',
            showDetail: 'Show detail'
          },
          details: 'Shadow IT details',
          integrateAsCustomApp: 'Integrate as custom SaaS',
          shadowId: 'Shadow Identity',
          title: 'Shadow IT',
          visitHistories: {
            freeText: 'Filter person by name, email...'
          }
        },
        tabs: {
          inactive: 'Inactive',
          noUser: 'No User',
          noWorker: 'Unidentified',
          shadowIt: 'Shadow IT',
          violatedAssignment: 'Violated Assignment',
          violatedRole: 'Violated Account Role'
        }
      },
      integrations: {
        actions: {
          refresh: 'Sync'
        },
        addIntegrationButton: 'Add Integration',
        assignPerson: 'Assign Person',
        changePerson: 'Change Person',
        columns: {
          app: {
            noTenantName: '(No tenant name)'
          },
          deleteDialog: {
            description: "{{name}}'s account will be deleted. This action cannot be undone.",
            successToast: 'Account deleted successfully',
            title: 'Delete {{name}}?'
          },
          pricingModel: {
            FIXED: 'Fixed',
            FREE: 'Free',
            HARDCODED: 'Unique',
            LINEAR: 'Linear',
            UNPREDICTABLE: 'Unpredictable'
          },
          renewalDate: {
            renewalDateIsWithinOneMonth: 'Renewal date is within one month'
          },
          unassignWorkerDialog: {
            description: 'The member assignment for {{name}} will be removed. The account itself will not be deleted.',
            successToast: 'Member assignment removed successfully'
          }
        },
        delete: 'Delete',
        filterIntegrationPlaceholder: 'Filter Software...',
        filters: {
          contractRenewalDate: 'Contract Renewal Date <light>is</light> in this month',
          groupSearchPlaceholder: 'Search groups...',
          roleSearchPlaceholder: 'Search for role...',
          statusSearchPlaceholder: 'Search for status...'
        },
        monthOverMonth: 'MoM',
        pageTitle: 'software/integrations',
        status: {
          refresh: {
            inProgress: 'Sync in progress',
            lastFailed: 'Last sync failed'
          }
        },
        systemAccount: {
          badgeSuggested: 'Possible System Account',
          markAction: 'Use as System Account',
          markDialog: {
            description: 'Treat this account as a system account (not tied to a person). It will be removed from alerts. You can optionally note its purpose.',
            noteLabel: 'Purpose note',
            notePlaceholder: 'e.g. Monitoring bot',
            successToast: 'Marked as system account',
            title: 'Use as System Account'
          },
          unmarkAction: 'Unmark System Account',
          unmarkDialog: {
            description: 'This account will no longer be treated as a system account and will return to the alerts list.',
            successToast: 'System account unmarked'
          }
        },
        tabs: {
          all: 'All',
          customApps: 'Custom SaaS',
          deactivated: 'Deactivated',
          integrations: 'Integrations'
        },
        title: 'Integrations',
        toast: {
          refresh: {
            alreadyInProgress: 'Already in progress',
            rateLimited: 'Rate limited',
            triggered: 'Sync started'
          }
        },
        unassignWorker: 'Unassign Worker'
      },
      marketplace: {
        addCustomApp: 'Add Custom SaaS',
        addIntegrationAsCustomApp: 'Add integration as custom SaaS',
        addIntegrationTitle: 'Add Integration',
        detailPage: {
          allPlanAvailable: 'Requires All Plan',
          authorizationInfo: 'Authorization Information',
          availablePlans: 'Requires {{value}}',
          // ex: Requires Free, Pro
          backButton: 'Add Integration',
          category: 'Category',
          contractInfo: 'Contract Information',
          functions: {
            manageUserGroups: 'Manage user groups',
            userCreate: 'Create users',
            userDeactivate: 'Deactivate users',
            userList: 'List all users'
          },
          functionsGridTitle: 'What you can do',
          information: 'You will need the following information to integrate',
          pageTitle: 'software/${{name}}',
          startIntegrationButton: 'Start integration',
          website: 'Website'
        },
        failedInstall: 'Failed to Authorized To {{appName}}',
        failedToInstallDialog: {
          goBackButton: 'Go back',
          title: 'Failed to integrate {{appName}}',
          tryAgainButton: 'Try again'
        },
        installAppDialog: {
          authentication: {
            label: 'Authentication',
            placeholder: 'Select Auth Method'
          },
          contractAnchor: {
            day: {
              placeholder: 'Select day'
            },
            label: 'Contract renewal date',
            month: {
              placeholder: 'Select month'
            },
            monthDayFormat: '<day/> / <month/>'
          },
          currency: {
            label: 'Currency',
            placeholder: 'Select currency'
          },
          description: 'Fill in the items below to bring the best out of the integration.',
          error: {
            appDetailsNotFound: 'Software details not found'
          },
          licenseSeat: {
            label: 'License Seat',
            placeholder: 'e.g. 5'
          },
          pricingPlan: {
            label: 'Pricing Plan',
            placeholder: 'Select Plan',
            searchPlaceholder: 'Search pricing plans'
          },
          submitButton: 'Continue to {{appName}}',
          subscription: {
            label: 'Subscription',
            placeholder: 'Select Subscription'
          },
          title: 'Integrate to {{appName}}',
          trainingMode: {
            description: 'Record user-list operations so an automated integration recipe can be configured.',
            label: 'Training mode'
          },
          useCustomPrice: 'Use custom price'
        },
        notFound: 'Sorry, No Software Found.',
        pageTitle: 'software - Add Integration',
        requestIntegration: 'Request Integration',
        searchAppAllCategories: 'All',
        searchAppPlaceholder: 'Search for software',
        title: 'Software'
      },
      orgSettings: pagesAppsOrgSettingsEn,
      people: {
        cards: {
          goToProfile: 'Go To Profile'
        },
        columns: {
          details: 'Details',
          noApps: 'No software',
          noDevices: 'No devices',
          showProfile: 'Show Profile'
        },
        filterPeoplePlaceholder: 'Filter by name...',
        filters: {
          app: 'Software',
          appCount: 'Software Count',
          appPlaceholder: 'Search for software',
          equalTo: 'equals to',
          filterLocationPlaceholder: 'Filter location...',
          filterOutput: '{{label}} <light>is</light> {{name}}',
          hasSomeApp: 'Has Some Software',
          isLessThan: 'is less than',
          isMoreThan: 'is more than',
          lessThan: 'less than',
          locationOfOffice: 'Location Of Office',
          model: 'Model',
          moreThan: 'more than',
          noResult: 'No results.',
          placePlaceholder: 'Search for work place',
          quantityFilterOutput: '{{label}} <light>{{text}}</light> {{amount}}',
          selected: '{{value}} selected',
          workerTypeKindLabel: {
            boardMember: 'Board member type',
            collaborator: 'Collaborator type',
            contractor: 'Contractor type',
            employee: 'Employment type'
          },
          workerTypePlaceholder: 'Search for worker types',
          workerTypeSearchPlaceholder: 'Search for {{label}}'
        },
        pageTitle: 'software/people',
        tabs: {
          all: 'All',
          joined: 'Joined',
          joining: 'Joining',
          leaving: 'Leaving'
        }
      },
      title: 'Software'
    },
    attendanceCore: pagesAttendanceCoreEn,
    attendanceEngine: pagesAttendanceEngineEn,
    attendances: pagesAttendancesEn,
    auth: pagesAuthEn,
    businessPartner: pagesBusinessPartnerEn,
    certification: pagesCertificationEn,
    cockpit: pagesCockpitEn,
    contract: {
      ...pagesContractEn,
      list: pagesContractListEn
    },
    contractingCorporationProfile: pagesContractingCorporationProfileEn,
    contractorCore: pagesContractorCoreEn,
    customerLedger: pagesCustomerLedgerEn,
    dataConnector: pagesDataConnectorEn,
    dealLedger: pagesDealLedgerEn,
    department: {
      list: {
        pageTitle: 'department/list',
        searchInputPlaceholder: 'Filter department...'
      },
      title: 'Department'
    },
    device: {
      error: {
        loadingFailed: 'Failed to load data',
        unknownError: 'An unknown error occurred'
      },
      profile: {
        mdm: pagesDeviceProfileMdmEn
      },
      status: {
        current: 'Current',
        timeline: 'Timeline'
      }
    },
    deviceCatalog: {
      active: {
        tabs: {
          contractAndCost: 'Contract and Cost',
          inventory: 'Device List',
          profile: 'Profile'
        },
        title: 'Device Catalog (Active)'
      },
      add: pagesDeviceCatalogAddEn,
      draft: {
        tabs: {
          profile: 'Profile'
        },
        title: 'Device Catalog (Draft)'
      },
      error: {
        loadingFailed: 'Failed to load data',
        unknownError: 'An unknown error occurred'
      },
      header: {
        actions: {
          activate: 'Activate',
          archive: 'Archive',
          delete: 'Delete'
        },
        activationDate: 'Activation Date:',
        archiveDate: 'Archive Date:',
        archiveDialog: {
          confirmButton: 'Archive',
          description: 'Are you sure you want to archive this device catalog?',
          reasonLabel: 'Archive Reason (Optional)',
          reasonPlaceholder: 'Enter the reason for archiving',
          successMessage: 'Device catalog archived successfully',
          title: 'Archive Confirmation'
        },
        catalogLabel: 'Catalog',
        deleteDialog: {
          confirmButton: 'Delete',
          description: 'Are you sure you want to delete this draft? This action cannot be undone.',
          descriptionWithName: 'Are you sure you want to delete "{{name}}"? This action cannot be undone.',
          successMessage: 'Draft deleted successfully',
          title: 'Delete Draft'
        },
        tabs: {
          profile: 'Profile'
        }
      },
      status: {
        active: 'Active',
        archived: 'Archived',
        draft: 'Draft'
      },
      validation: {
        required: '{{field}} is required'
      }
    },
    devices: {
      add: pagesDevicesAddEn,
      addDevice: 'Add Device',
      alerts: pagesDevicesAlertsEn,
      columns: {
        assignDevice: 'Assign Device',
        decommission: 'Decommission',
        openMenu: 'Open Menu',
        putInMaintenance: 'Put in maintenance',
        recoverFromMaintenance: 'Recover from maintenance',
        showDevice: 'Show Device'
      },
      detail: {
        error: {
          loadFailed: 'Failed to load data',
          sectionNotFound: 'Section not found: {{key}}'
        },
        saveSuccess: 'Saved successfully',
        validation: {
          required: '{{field}} is required'
        }
      },
      filters: {
        computer: 'Computer',
        deviceTypePlaceholder: 'Filter device type...',
        manufacturerPlaceholder: 'Filter MFR...'
      },
      header: {
        assetLabel: 'Asset',
        assigned: 'Assigned',
        available: 'Available',
        computer: 'Computer',
        decommissioned: 'Decommissioned',
        inDistribution: 'In Distribution',
        placed: 'Placed',
        purchasedFrom: 'Purchased From',
        refurbishing: 'Refurbishing',
        tagLabel: 'Tag',
        unassigned: 'Unassigned',
        underMaintenance: 'Under Maintenance',
        underRepair: 'Under Repair'
      },
      importCsv: {
        checkValidColumn: {
          errors: 'Errors'
        },
        completeDialog: {
          button: 'Go to Inventory',
          message: 'Successfully Imported!'
        },
        completeLinkButton: 'Go to Inventory',
        deviceType: {
          prepareCsvFile: {
            templateTitle: {
              computer: 'New computers',
              mobile: 'New mobiles',
              monitor: 'New monitors',
              other: 'New others',
              printer: 'New printers',
              server: 'New servers'
            },
            updateExisting: {
              computer: 'Update existing computers',
              mobile: 'Update existing mobiles',
              monitor: 'Update existing monitors',
              other: 'Update existing others',
              printer: 'Update existing printers',
              server: 'Update existing servers'
            }
          },
          title: {
            computer: 'Bulk Add Computer',
            mobile: 'Bulk Add Mobile',
            monitor: 'Bulk Add Monitor',
            other: 'Bulk Add Other',
            printer: 'Bulk Add Printer',
            server: 'Bulk Add Server'
          },
          unit: {
            computers: 'computers',
            mobiles: 'mobiles',
            monitors: 'monitors',
            others: 'others',
            printers: 'printers',
            servers: 'servers'
          }
        },
        filename: 'Devices',
        templateTitle: 'New devices',
        title: 'Bulk Add Devices',
        unit: 'devices',
        updateExisting: 'Update existing devices'
      },
      inventories: {
        actions: {
          openMenu: 'Open menu',
          showDetail: 'Show Detail'
        },
        addDevice: 'Add Device',
        categories: {
          all: {
            title: 'All'
          },
          decommissioned: {
            title: 'Decommissioned'
          },
          inDistribution: {
            title: 'Under Procurement'
          },
          inInventory: {
            all: 'All',
            available: 'Available',
            faulty: 'Faulty',
            refurbishing: 'Refurbishing',
            title: 'In Inventory'
          },
          inUse: {
            all: 'All',
            assigned: 'Assigned',
            placed: 'Placed',
            title: 'In Use'
          },
          underRepair: {
            title: 'Under Repair'
          }
        },
        filterPlaceholder: 'Filter devices...',
        filters: {
          placementPlace: 'Installation Location',
          refurbishingPlace: 'Refurbishment Location',
          warehousingPlace: 'Storage Location'
        },
        pageTitle: 'devices/inventory'
      },
      inventory: {
        actions: {
          backToAvailable: 'Back to Available',
          changeAssignee: 'Change Assignee',
          delete: 'Delete',
          dispose: 'Dispose',
          finishMaintain: 'Finish Maintain',
          maintain: 'Maintain',
          openMenu: 'Open menu'
        },
        addDevice: 'Add Device',
        filterDevicePlaceholder: 'Filter by devices...',
        filterPlaceholder: 'Filter devices...',
        goToProfile: 'Go To Profile',
        pageTitle: 'devices/inventory',
        status: {
          assigned: 'assigned',
          available: 'available',
          disposed: 'disposed',
          hidden: 'hidden',
          maintenance: 'maintenance'
        },
        tabs: {
          all: 'All devices',
          assigned: 'Assigned',
          available: 'Available',
          decommissioned: 'Decommissioned',
          inDistribution: 'In Distribution',
          placed: 'Placed',
          underMaintenance: 'Under Maintenance'
        },
        unassiged: 'Unassigned'
      },
      overview: {
        pageTitle: 'devices/overview',
        // 基本辞書順にフラットに並べる（小文字を原則として使い回せるように）
        assignmentOrPlacement: 'Assignment / Placement',
        decommission: 'Decommission',
        devices: 'devices',
        others: 'Others',
        persons: 'persons',
        places: 'places',
        prcForce: 'PRC Force',
        recentActivity: 'recent activity',
        schedule: 'schedule',
        thisMonth: 'this month',
        thisWeek: 'this week',
        tomorrow: 'tomorrow'
      },
      profile: {
        deviceInventory: {
          actionMemo: 'Action Memo',
          deviceCondition: {
            bad: 'Bad',
            good: 'Good',
            label: 'Device Condition'
          },
          lastPhysicalCheckDate: 'Last Physical Check Date',
          memo: 'Memo',
          reportResult: {
            label: 'Inventory Result',
            lost: 'Lost',
            notKnown: 'Invalid',
            other: 'Other',
            owned: 'Valid',
            returned: 'Returned'
          },
          reportedAt: 'Reported At',
          reportedBy: 'Reported By',
          title: 'Inventory Report',
          verificationMethod: {
            assetTag: 'Asset Tag',
            informal: 'Informal',
            label: 'Verification Method',
            photoRecord: 'Photo Record',
            physicalCheck: 'Physical Check',
            representativeByStaff: 'Representative by Staff',
            scan: 'Scan'
          }
        },
        dialog: {
          release: {
            description_assignment: 'Releasing the user will change the device status from assigned to available.',
            description_placement: 'Releasing the placement will change the device status.',
            description_responsiblePerson: "Releasing the responsible person will remove the device's responsible person information.",
            description_warehousingPlace: 'Releasing the warehousing place will change the device status.',
            endDate_assignment: 'End Date',
            endDate_placement: 'End Date',
            endDate_responsiblePerson: 'End Date',
            endDate_warehousingPlace: 'End Date',
            endDateLessThanStartDate: 'End Date must be after {{startDate}}.',
            endDateRequired: 'End Date is required.',
            title_assignment: 'Release User',
            title_placement: 'Release Placement',
            title_responsiblePerson: 'Release Responsible Person',
            title_warehousingPlace: 'Release Warehousing Place',
            triggerButton_assignment: 'Release User',
            triggerButton_placement: 'Release Placement',
            triggerButton_responsiblePerson: 'Release Responsible Person',
            triggerButton_warehousingPlace: 'Release Warehousing Place'
          }
        },
        navigation: {
          audit: 'Audit',
          button: {
            assignDevice: 'Assign Device',
            assignUser: 'Assign User',
            changeAssignment: 'Change Assignment',
            changePlacement: 'Change Placement',
            changeResponsiblePerson: 'Change Responsible Person',
            changeStatus: 'Change Device Status',
            changeUser: 'Change User',
            changeWarehousingPlace: 'Change Warehousing Place',
            decommission: 'Decommission',
            putIntoMaintenance: 'Put in maintenance',
            recoverFromMaintenance: 'Recover from maintenance',
            releaseUser: 'Release User'
          },
          contract: 'Contract',
          lifecycle: 'Lifecycle',
          network: 'Network',
          planning: 'Planning',
          sectionTitle: {
            base: 'Device ID Information',
            battery: 'Battery',
            bios: 'BIOS',
            deviceInventory: 'Device Inventory',
            display: 'Display',
            gpu: 'GPU',
            leaseContract: 'Lease Contract',
            logsAudit: 'Logs & Audit',
            maintenanceRepair: 'Maintenance & Repair',
            mdmAssetManagement: 'Asset Management Information',
            mdmDataSource: 'Data Source',
            mdmHardwareInfo: 'Hardware Information',
            mdmNetworkInfo: 'Network Information',
            mdmOperationLog: 'Operation Log',
            mdmOsInfo: 'OS Information',
            mdmSecurityStatus: 'Security Status',
            mdmSoftwareInfo: 'Software Information',
            network: 'Network',
            networkAndSim: 'Network & SIM',
            networkConfiguration: 'Network Configuration',
            os: 'OS',
            placement: 'Placement',
            placementDetail: 'Placement Detail',
            placementStatus: 'Placement Status',
            planningBudgeting: 'Planning & Budgeting',
            policiesAndProfiles: 'Policies & Profiles',
            port: 'Port',
            processor: 'Processor',
            procurementAcquisition: 'Procurement & Acquisition',
            provisioningDeployment: 'Provisioning & Deployment',
            ram: 'RAM',
            remoteManagementFeatures: 'Remote Management Features',
            remoteManagementHistory: 'Remote Management History',
            responsiblePerson: 'Responsible Person',
            // MDM Section Titles
            retirementDisposal: 'Retirement & Disposal',
            securityConfiguration: 'Security Configuration',
            securityStatus: 'Security Status',
            statusAndHealth: 'Status & Health',
            storage: 'Storage',
            transportAndMovement: 'Transport & Movement',
            upgradeRedeployment: 'Upgrade & Redeployment',
            usageOperation: 'Usage & Operation',
            // Contract
            user: 'User',
            // DeviceInventory
            warehousingPlace: 'Warehousing Place'
          },
          security: 'Security',
          title: 'Device Profile'
        },
        notRegistered: 'Not Registered',
        sections: {
          base: {
            assetTag: 'Asset Tag',
            deviceTag: 'Inventory ID',
            generateLabel: 'Generate Label',
            id: 'Device ID',
            imei: 'IMEI',
            imei2: 'IMEI2',
            managementLabel: 'Management Label',
            manufacturer: 'Manufacturer',
            memo: 'Memo',
            model: 'Model',
            modelNumber: 'Model Number',
            name: 'Name',
            regenerateLabel: 'Regenerate Label',
            serialNumber: 'Serial Number',
            tagsTooltipDialog: {
              assetTagDescription: 'Any value you need to set for managing your assets.',
              description: 'Description',
              deviceTagDescription: 'It is used when a device-specific management ID is required in addition to the asset tag.',
              itemName: 'Item Name'
            },
            type: 'Type'
          },
          battery: {
            batteryLevelPercent: 'Battery Level (%)',
            batteryModelName: 'Battery Model Name',
            batteryPresence: 'Battery Presence',
            batterySerialNumber: 'Battery Serial Number',
            batteryType: 'Battery Type',
            capacityUnit: 'Capacity Unit',
            current: 'Current',
            currentCharge: 'Current Charge',
            designCapacity: 'Design Capacity',
            fullChargeCapacity: 'Full Charge Capacity',
            manufactureDate: 'Manufacture Date',
            manufacturer: 'Manufacturer',
            voltage: 'Voltage',
            wearLevelPercent: 'Wear Level (%)'
          },
          computer: {
            cpuArchitecture: 'CPU Architecture',
            cpuClockMhz: 'CPU Clock (MHz)',
            cpuCoreCount: 'Core Count',
            cpuManufacturer: 'CPU Manufacturer',
            cpuModel: 'CPU Model',
            cpuProcessorCount: 'Processor Count',
            osBuild: 'OS Build',
            osName: 'OS Name',
            osPlatform: 'Platform',
            osVersion: 'OS Version',
            totalStorageMB: 'Total Storage (MB)',
            type: 'Computer Type'
          },
          firmware: {
            biosLock: 'BIOS Lock / Write Protection',
            biosPasswordSet: 'BIOS Password Set',
            biosReleaseDate: 'BIOS Release Date',
            biosRomSizeBytes: 'BIOS ROM Size',
            biosUpdateEnabled: 'BIOS Update Enabled',
            biosVendor: 'BIOS Vendor',
            biosVersion: 'BIOS Version',
            bootSequenceOrder: 'Boot Sequence / Order',
            firmwareMode: 'Firmware Mode',
            firmwareType: 'Firmware Type',
            hardwareEncryptionSupport: 'Hardware Encryption Support',
            intelTxtEnabled: 'Intel Trusted Execution Technology',
            motherboardModel: 'Motherboard Model',
            oemBiosCustomization: 'OEM BIOS Customization',
            pxeBootEnabled: 'PXE Boot Enabled',
            secureBootEnabled: 'Secure Boot Enabled',
            smbiosVersion: 'SMBIOS Version',
            systemManufacturer: 'System Manufacturer',
            systemModel: 'System Model',
            systemSerialNumber: 'System Serial Number',
            systemUuid: 'System UUID',
            tpmEnabled: 'TPM Enabled',
            tpmVersion: 'TPM Version',
            wakeOnLanEnabled: 'Wake-on-LAN Status'
          },
          gpu: {
            clockSpeedBaseHz: 'Clock Speed (Base Hz)',
            clockSpeedBoostHz: 'Clock Speed (Boost Hz)',
            cudaCores: 'CUDA Cores',
            dedicatedGpuMemoryBytes: 'Dedicated GPU Memory (Bytes)',
            driverProvider: 'Driver Provider',
            driverVersion: 'Driver Version',
            gpuArchitecture: 'GPU Architecture',
            gpuGeneration: 'GPU Generation',
            gpuModelNumber: 'GPU Model Number',
            gpuName: 'GPU Name',
            gpuTemperatureC: 'GPU Temperature (°C)',
            gpuUsagePercent: 'GPU Usage (%)',
            gpuVendor: 'GPU Vendor',
            hardwareAcceleration: 'Hardware Acceleration',
            maxDisplaySupport: 'Max Display Support',
            shaderUnits: 'Shader Units',
            sharedGpuMemoryBytes: 'Shared GPU Memory (Bytes)',
            supportedApis: 'Supported APIs',
            totalAvailableGpuMemoryMB: 'Total Available GPU Memory (MB)',
            totalGpuMemoryBytes: 'Total GPU Memory (Bytes)'
          },
          leaseContract: {
            contractEndDate: 'Contract End Date',
            contractId: 'Contract ID',
            contractNo: 'Contract Number',
            contractStartDate: 'Contract Start Date',
            deviceIntroductionDate: 'Device Introduction Date',
            deviceMonthlyLeaseFee: 'Device Monthly Lease Fee',
            deviceProcurementPrice: 'Device Procurement Price',
            monthlyLeaseFee: 'Monthly Lease Fee'
          },
          logsAudit: {
            alertViolationHistory: 'Alert Violation History',
            auditLogs: 'Audit Logs',
            complianceStatus: 'Compliance Status',
            inventoryStatus: 'Inventory Status'
          },
          maintenanceRepair: {
            failureDate: 'Failure Date',
            failureDescription: 'Failure Description',
            incidentFailureId: 'Incident Failure ID',
            repairCompletedDate: 'Repair Completed Date',
            repairCost: 'Repair Cost',
            repairDescription: 'Repair Description',
            repairRequestDate: 'Repair Request Date',
            replacementAssetId: 'Replacement Asset ID',
            technician: 'Technician',
            vendor: 'Vendor'
          },
          mdm: {
            // Data Source Section
            assetManagement: {
              assetNumber: 'Asset Number',
              assignedDepartment: 'Assigned Department',
              assignmentDate: 'Assignment Date',
              currentUser: 'Current User',
              deviceRegistrationState: 'Device Registration State',
              emailAddress: 'Email Address',
              enrolledDateTime: 'Enrollment Date',
              lastSyncDateTime: 'Last Sync Date',
              managedDeviceOwnerType: 'Managed Device Owner Type',
              purchaseDate: 'Purchase Date',
              purchasePrice: 'Purchase Price',
              userDisplayName: 'User Display Name'
            },
            // Hardware Information Section
            dataSource: {
              linkedApp: 'Linked Software'
            },
            // Network Information Section
            hardware: {
              batteryHealth: 'Battery Health',
              batteryLevel: 'Battery Level',
              biosVersion: 'BIOS Version',
              chargingStatus: 'Charging Status',
              deviceName: 'Device Name',
              deviceType: 'Device Type',
              manufacturer: 'Manufacturer',
              modelNumber: 'Model Number',
              processorName: 'CPU',
              ramCapacity: 'Total Memory Capacity',
              serialNumber: 'Serial Number',
              storageCapacity: 'Total Storage Capacity'
            },
            // OS Information Section
            network: {
              bluetoothConnection: 'Bluetooth Connection Info',
              dnsServer: 'DNS Server',
              ethernetMacAddress: 'Ethernet MAC Address',
              gateway: 'Gateway',
              ipAddress: 'IP Address',
              subnetMask: 'Subnet Mask',
              subscriberCarrier: 'Carrier',
              wifiMacAddress: 'WiFi MAC Address',
              wifiSsid: 'WiFi SSID'
            },
            // Asset Management Information Section
            os: {
              osName: 'OS Name',
              osType: 'OS Type',
              osVersion: 'OS Version',
              servicePackPatchLevel: 'Service Pack/Patch Level'
            },
            // Security Status Section
            security: {
              adminPrivileges: 'Admin Privileges',
              diskEncryption: 'Disk Encryption',
              diskEncryptionLabel: 'Disk Encryption',
              diskEncryptionStatus: {
                disabled: 'Disabled',
                enabled: 'Enabled'
              },
              firewallSettings: 'Firewall Settings',
              jailbreakStatus: {
                jailbroken: 'Jailbroken',
                notJailbroken: 'Not Jailbroken'
              },
              // Boolean value labels
              jailbreakStatusLabel: 'Jailbreak Status',
              passwordPolicyCompliance: 'Password Policy Compliance',
              systemIntegrityProtection: 'System Integrity Protection (SIP)'
            },
            // Software Information Section
            software: {
              appUsage: 'Software Usage',
              appVersion: 'Software Version',
              installedApps: 'Installed Software',
              prohibitedAppDetection: 'Prohibited Software Detection'
            }
          },
          monitor: {
            activePortUsed: 'Active Port Used',
            aspectRatio: 'Aspect Ratio',
            brightness: 'Brightness',
            colorGamut: 'Color Gamut',
            contrastRatio: 'Contrast Ratio',
            displayArrangement: 'Display Arrangement',
            displayType: 'Display Type',
            inputPorts: 'Input Ports',
            manufactureDate: 'Manufacture Date',
            numberOfColors: 'Number of Colors',
            panelType: 'Panel Type',
            refreshRateHz: 'Refresh Rate (Hz)',
            resolutionHeight: 'Resolution Height',
            resolutionWidth: 'Resolution Width',
            rotationPivotMode: 'Rotation/Pivot Mode',
            sizeInInch: 'Size (Inch)',
            touchCapability: 'Touch Capability'
          },
          network: {
            connectionType: 'Connection Type',
            defaultGateway: 'Default Gateway',
            dhcpEnabled: 'DHCP Enabled',
            dnsServer: 'DNS Server',
            domainName: 'Domain Name',
            driverName: 'Driver Name',
            fullyQualifiedDomainName: 'Fully Qualified Domain Name (FQDN)',
            hostname: 'Hostname',
            interfaceType: 'Interface Type',
            ipAssignmentSource: 'IP Assignment Source',
            ipv4Address: 'IPv4 Address',
            ipv6Address: 'IPv6 Address',
            macAddress: 'MAC Address',
            networkInterfaceName: 'Network Interface Name',
            nicVendor: 'NIC Vendor',
            numberOfConnectedDisplays: 'Number of Connected Displays',
            staticIpConfigured: 'Static IP Configured',
            subnetMask: 'Subnet Mask',
            type: 'Network Type'
          },
          networkAndSim: {
            connectedWifiSsid: 'Connected Wi-Fi SSID',
            iccid: 'ICCID Number',
            ipAddress: 'IP Address',
            mobileCarrier: 'Mobile Carrier',
            networkStatus: 'Network Status',
            phoneNumber: 'Phone Number',
            simStatus: 'SIM Status'
          },
          networkConfiguration: {
            connectedSsidVpn: 'Connected SSID / VPN',
            connectionHistory: 'Connection History',
            dnsSettings: 'DNS Settings',
            hostname: 'Hostname',
            proxyConfiguration: 'Proxy Configuration'
          },
          networkInterface: {
            connectionType: 'Connection Type',
            defaultGateway: 'Default Gateway',
            dhcpEnabled: 'DHCP Enabled',
            dnsServer: 'DNS Server',
            domainName: 'Domain Name',
            driverName: 'Driver Name',
            fqdn: 'Fully Qualified Domain Name (FQDN)',
            hostname: 'Hostname',
            interfaceType: 'Interface Type',
            ipAssignmentSource: 'IP Assignment Source',
            ipv4Address: 'IPv4 Address',
            ipv6Address: 'IPv6 Address',
            macAddress: 'MAC Address',
            networkInterfaceName: 'Network Interface Name',
            nicVendor: 'NIC Vendor',
            staticIpConfigured: 'Static IP Configured',
            subnetMask: 'Subnet Mask'
          },
          os: {
            antivirusSoftwareCompatibility: 'AV Software Compatibility',
            architecture: 'Architecture',
            automaticUpdatesEnabled: 'Automatic Updates Enabled',
            bitness: 'Bitness',
            bootMode: 'Boot Mode',
            buildNumber: 'Build Number',
            diskEncryptionEnabled: 'Disk Encryption Enabled',
            firewallStatus: 'Firewall Status',
            kernelVersion: 'Kernel Version',
            operatingSystemType: 'Operating System Type',
            osEdition: 'OS Edition',
            osInstallDate: 'OS Install Date',
            osName: 'OS Name',
            osSupportLifecycle: 'OS Support Lifecycle',
            osVersion: 'OS Version',
            securityPatchDate: 'Security Patch Date',
            servicePackPatchLevel: 'Service Pack / Patch Level',
            withVirtualOs: 'With Virtual OS'
          },
          placement: {
            areaZoneName: 'Area / Zone Name',
            areaZoneNamePlaceholder: 'Enter area/zone name',
            buildingName: 'Building Name',
            buildingNamePlaceholder: 'Enter building name',
            deskSeatNumber: 'Desk / Seat Number',
            deskSeatNumberPlaceholder: 'Enter desk/seat number',
            floorNumber: 'Floor Number',
            floorNumberPlaceholder: 'Enter floor number',
            from: 'From',
            gpsBleTagId: 'GPS / BLE Tag ID',
            gpsBleTagIdPlaceholder: 'Enter GPS/BLE tag ID',
            labelStickerId: 'Label / Sticker ID',
            labelStickerIdPlaceholder: 'Enter label/sticker ID',
            notes: 'Notes',
            notesPlaceholder: 'Enter notes',
            placementCode: 'Placement Site Code',
            placementDate: 'Placement Date',
            placementDocumentLink: 'Placement Document Link',
            placementDocumentLinkPlaceholder: 'Enter placement document URL',
            placementEndDate: 'Placement End Date',
            placementName: 'Placement Name',
            placementStartDate: 'Placement Start Date',
            placementType: 'Placement/Storage Type',
            placementTypeOptions: {
              FIXED: 'Fixed',
              FREE: 'Free',
              OTHER: 'Other',
              UNKNOWN: 'Unknown'
            },
            reasonForPlacement: 'Reason for Placement',
            reasonForPlacementPlaceholder: 'Enter placement reason',
            siteOfficeName: 'Site / Office Name',
            siteOfficeNamePlaceholder: 'Enter site/office name',
            to: 'To'
          },
          placementDetail: {
            locationPhotoUrl: 'Location Photo URL',
            physicalEnvironment: 'Physical Environment',
            placementCondition: 'Placement Condition',
            placementDepthCentimeter: 'Placement Depth',
            placementHeightCentimeter: 'Placement Height',
            placementWidthCentimeter: 'Placement Width',
            rackNumber: 'Rack Number',
            rackUPosition: 'Rack U Position',
            shelfCabinetNumber: 'Shelf / Cabinet Number'
          },
          placementStatus: {
            lastPhysicalCheckDate: 'Last Physical Check Date',
            lastUpdatedDate: 'Last Updated Date',
            placementStatus: 'Placement Status',
            placementVerificationStatus: 'Placement Verification Status',
            verificationMethod: 'Verification Method',
            verificationStatusOptions: {
              MATCH: 'Match',
              MISMATCH: 'Mismatch',
              NOT_CHECKED: 'Not Checked'
            }
          },
          planningBudgeting: {
            budgetAllocation: 'Budget Allocation',
            evaluationNotes: 'Evaluation Notes',
            plannedQuantity: 'Planned Quantity',
            planningDepartment: 'Planning Department',
            procurementPlanId: 'Procurement Plan ID',
            procurementPurpose: 'Procurement Purpose',
            requester: 'Requester',
            vendorCandidate: 'Vendor Candidate'
          },
          policiesAndProfiles: {
            appliedPolicyName: 'Applied Policy Name',
            dateApplied: 'Date Applied',
            restrictions: 'Restrictions (USB Disable, External Media Block)',
            scriptProfileExecutionHistory: 'Script / Profile Execution History',
            wifiVpnCertificateProfiles: 'Wi-Fi / VPN / Certificate Profiles'
          },
          port: {
            numOfPorts: 'Number of Ports',
            specification: 'Specification',
            type: 'Port Type'
          },
          processor: {
            cpuCacheSizeL1Bytes: 'Cache Size L1 (Bytes)',
            cpuCacheSizeL2Bytes: 'Cache Size L2 (Bytes)',
            cpuCacheSizeL3Bytes: 'Cache Size L3 (Bytes)',
            cpuClockSpeedHz: 'CPU Clock Speed (Hz)',
            cpuCoreCount: 'CPU Core Count',
            cpuGeneration: 'CPU Generation',
            cpuMaxTurboFrequencyHz: 'Max Turbo Frequency (Hz)',
            cpuName: 'CPU Name',
            cpuProcessNode: 'Process Node',
            cpuSeries: 'CPU Series',
            cpuSocketType: 'Socket Type',
            cpuTdpWatt: 'Thermal Design Power (TDP)',
            cpuThreadCount: 'CPU Number of Threads',
            cpuVendor: 'CPU Vendor'
          },
          procurementAcquisition: {
            assetIdInventoryId: 'Asset ID Inventory ID',
            maintenanceContractId: 'Maintenance Contract ID',
            modelNumber: 'Model Number',
            procurementDate: 'Procurement Date',
            procurementType: 'Procurement Type',
            productName: 'Product Name',
            purchaseCondition: 'Condition',
            purchaseCostCurrency: 'Purchase Cost Currency',
            purchaseCostTaxExcluded: 'Purchase Cost (Tax Excluded)',
            purchaseCostTaxIncluded: 'Purchase Cost (Tax Included)',
            serialNumber: 'Serial Number',
            vendorSupplierName: 'Vendor Supplier Name',
            warrantyExpiryDate: 'Warranty Expiry Date',
            warrantyStartDate: 'Warranty Start Date'
          },
          provisioningDeployment: {
            assignedUserEmployeeNumber: 'Assigned User / Employee Number',
            deploymentDate: 'Deployment Date',
            deploymentDepartment: 'Deployment Department',
            mdmEnrollmentStatus: 'MDM Enrollment Status',
            osInstallationType: 'OS Installation Type',
            securityProfileApplied: 'Security Profile Applied',
            setupCompletedDate: 'Setup Completed Date',
            userAgreementSignedUrl: 'User Agreement Signed URL'
          },
          ram: {
            ramEccSupported: 'ECC Supported',
            ramFormFactor: 'RAM Form Factor',
            ramGeneration: 'Memory Type',
            ramJedecCompliant: 'JEDEC Compliant',
            ramManufactureDate: 'Manufacture Date',
            ramManufacturer: 'Manufacturer',
            ramPartNumber: 'Part Number',
            ramRegistered: 'Registered / Unbuffered',
            ramSerialNumber: 'Serial Number',
            ramSizeBytes: 'RAM Size (Bytes)',
            ramSpeedHz: 'RAM Speed (Hz)',
            totalSizeBytes: 'Total Size (Bytes)'
          },
          remoteManagementFeatures: {
            lockScreenMessage: 'Lock Screen Message',
            remoteCommandHistory: 'Remote Command History',
            remoteLockStatus: 'Remote Lock Status',
            remoteWipeAvailability: 'Remote Wipe Availability'
          },
          remoteManagementHistory: {
            executionTime: 'Execution Time',
            issuedBy: 'Issued By',
            lastRemoteCommand: 'Last Remote Command'
          },
          responsiblePerson: {
            assetId: 'Asset ID',
            assignmentStartDate: 'Assignment Start Date',
            byodDeregistrationDate: 'BYOD Deregistration Date',
            byodPurpose: 'BYOD Purpose',
            byodRegistrationDate: 'BYOD Registration Date',
            deviceTag: 'Device Tag',
            deviceType: 'Device Type',
            employeeNumber: 'Responsible Person Employee Number',
            expectedReturnDate: 'Expected Return Date',
            lastAuditDate: 'Last Audit Date',
            notes: 'Notes',
            numberOfAssetsManaged: 'Number of Assets Managed',
            ownerCompany: "Owner's Company",
            ownerConfirmedFlag: 'Owner Confirmed Flag',
            ownerDepartment: "Owner's Department",
            ownerEmployeeNumber: 'Owner Employee Number',
            ownerName: 'Owner Name',
            ownershipStartDate: 'Ownership Start Date',
            physicalVerifiedFlag: 'Physical Verified Flag',
            registeredBy: 'Registered By',
            responsibleConfirmedFlag: 'Responsible Confirmed Flag',
            responsibleDepartment: 'Responsible Department',
            responsiblePersonName: 'Responsible Person Name',
            scopeOfResponsibility: 'Scope of Responsibility',
            scopeOfResponsibilityPlaceholder: 'Enter scope of responsibility',
            validTimeFrom: 'Assignment Start Date',
            validTimeTo: 'Assignment End Date'
          },
          retirementDisposal: {
            accountingDeregistrationDate: 'Accounting Deregistration Date',
            accountingDeregistrationReason: 'Accounting Deregistration Reason',
            dataWipeDate: 'Data Wipe Date',
            decommissionDate: 'Disposal Date',
            decommissionReason: 'Disposal Reason',
            disposalCertificateAttached: 'Disposal Certificate Attached',
            disposalMethod: 'Disposal Method',
            scheduledDecommissionDate: 'Disposal Decision Date',
            wipeMethod: 'Wipe Method'
          },
          securityConfiguration: {
            deviceCertificate: 'Device Certificate',
            deviceEncryption: 'Device Encryption',
            factoryResetProtection: 'Factory Reset Protection',
            jailbreakRootDetection: 'Jailbreak / Root Detection',
            lostModeStatus: 'Lost Mode Status',
            mdmManagementStatus: 'MDM Management Status',
            passcodeEnabled: 'Passcode Enabled',
            passcodePolicyCompliant: 'Passcode Policy Compliant',
            remoteWipeEnabled: 'Remote Wipe Enabled',
            securityPatchLevel: 'Security Patch Level'
          },
          securityStatus: {
            adminPrivileges: 'Admin Privileges',
            antivirusStatus: 'Antivirus Status',
            diskEncryption: 'Disk Encryption (BitLocker / FileVault)',
            firewallSettings: 'Firewall Settings',
            passwordPolicyCompliance: 'Password Policy Compliance',
            tamperProtectionStatus: 'Tamper Protection Status',
            userLoginHistory: 'User Login History'
          },
          statusAndHealth: {
            batteryLevel: 'Battery Level',
            chargingStatus: 'Charging Status',
            devicePhotoUploadDialog: {
              photoLabel: 'Label',
              photoLabelPlaceholder: 'Enter label...',
              uploadPhoto: 'Upload Photo'
            },
            devicePhotos: 'Device Photos',
            deviceTemperature: 'Device Temperature',
            lastCheckInTime: 'Last Check-In Time'
          },
          storage: {
            capacityMB: 'Capacity (MB)',
            name: 'Product Name / Model',
            storageCacheSizeBytes: 'Cache Size (Bytes)',
            storageFirmwareVersion: 'Firmware Version',
            storageFormFactor: 'Form Factor',
            storageInterfaceType: 'Interface Type',
            storageManufacturer: 'Manufacturer',
            storageNandType: 'NAND Type',
            storageSerialNumber: 'Serial Number',
            storageSlotNumber: 'Slot Number',
            storageTrimSupport: 'TRIM Support',
            type: 'Storage Type'
          },
          transportAndMovement: {
            deliveryTransferDate: 'Delivery/Transfer Date',
            destinationLocation: 'Destination Location',
            sourceLocation: 'Source Location',
            transportBy: 'Transport By',
            transportReason: 'Transport Reason',
            transportStatus: 'Transport Status'
          },
          upgradeRedeployment: {
            newAssignedUser: 'New Assigned User',
            redeploymentDate: 'Redeployment Date',
            refreshDecisionDate: 'Refresh Decision Date',
            refreshReason: 'Refresh Reason',
            resetWipeDate: 'Reset Wipe Date',
            sourceAssetId: 'Source Asset ID'
          },
          usageOperation: {
            batteryWearLevel: 'Battery Wear Level',
            loginIdDeviceAccount: 'Login ID Device Account',
            monthlyDataUsage: 'Monthly Data Usage',
            operationalStatus: 'Operational Status',
            plannedReturnDate: 'Planned Return Date',
            securityCompliance: 'Security Compliance',
            storageUsage: 'Storage Usage',
            usageStartDate: 'Usage Start Date'
          },
          users: {
            actualReturnDate: 'Actual Return Date',
            assignmentStartDate: 'Loan Start Date',
            departmentCode: 'Department Code',
            departmentName: 'Department Name',
            emailAddress: 'Email Address',
            employeeNumber: 'User Employee Number',
            employmentStatus: 'Employment Status',
            expectedReturnDate: 'Expected Loan End Date',
            fullNameEnglish: 'User Name (English)',
            handoverDate: 'Handover Date',
            jobTitle: 'Job Title',
            loginId: 'Login ID / Account ID',
            managerSupervisor: 'Manager / Supervisor',
            officeLocation: 'Office Location',
            personInCharge: 'Person in charge',
            phoneNumber: 'Phone Number',
            primarySecondaryDevice: 'Primary / Secondary Device',
            registeredBy: 'Registered By',
            teamGroupName: 'Team / Group Name',
            usageAgreementSigned: 'Usage Agreement Signed',
            usageLocation: 'Usage Location',
            usageRestrictions: 'Usage Restrictions',
            usageStatus: 'Usage Status',
            usageType: 'Usage Type',
            userName: 'User Name',
            userOrganization: 'User Organization',
            workType: 'Work Type'
          },
          // MDM Integration Sections
          warehousingPlace: {
            areaZoneName: 'Area Zone Name',
            areaZoneNamePlaceholder: 'Enter area zone name',
            buildingName: 'Warehousing Building Name',
            buildingNamePlaceholder: 'Enter warehousing building name',
            deskAndSeatNumber: 'Desk and Seat Number',
            deskAndSeatNumberPlaceholder: 'Enter desk and seat number',
            floorNumber: 'Floor Number',
            floorNumberPlaceholder: 'Enter floor number',
            rackNumber: 'Rack Number',
            rackNumberPlaceholder: 'Enter Rack Number',
            rackUPosition: 'Rack U Position',
            rackUPositionPlaceholder: 'Enter Rack U Position',
            shelfCabinetNumber: 'Shelf/Cabinet Number',
            shelfCabinetNumberPlaceholder: 'Enter Shelf/Cabinet Number',
            storageType: 'Storage Type',
            storageTypeOptions: {
              IN_STOCK: 'In Stock',
              REFURBISHING: 'Refurbishing',
              TEMPORARILY_STORED: 'Temporarily Stored',
              WAITING_FOR_DISPOSAL: 'Waiting for Disposal'
            },
            storageTypePlaceholder: 'Enter storage type',
            warehousingDate: 'Warehousing Start Date',
            warehousingEndDate: 'Warehousing End Date',
            warehousingPlaceCode: 'Warehousing Place Code',
            warehousingPlaceName: 'Storage Site Name',
            warehousingPlaceStatus: 'Warehousing Place Status'
          }
        }
      },
      title: 'Devices',
      ...pagesDevicesCatalogEn,
      contractAndCost: pagesDevicesContractAndCostEn,
      externalItSaas: pagesDevicesExternalItSaasEn,
      file: pagesDevicesFileEn,
      people: {
        addDevice: 'Add Device',
        changeDevices: 'Change Devices',
        filterPlaceholder: 'Filter by name, email...',
        filters: {
          device: 'Device',
          equalTo: 'equals to',
          filterOutput: '{{label}} <light>is</light> {{name}}',
          hasSomeDevice: 'Has Some Device',
          hiredAt: 'Hire At',
          isLessThan: 'is less than',
          isMoreThan: 'is more than',
          lessThan: 'less than',
          locationOfOffice: 'Location Of Office',
          model: 'Model',
          moreThan: 'more than',
          offboardedAt: 'Offboarded At',
          organization: 'Organization',
          person: 'Person',
          personallyOwned: 'Personally Owned',
          quantityFilterOutput: '{{label}} <light>{{text}}</light> {{name}}',
          selected: '{{value}} selected'
        },
        openMenu: 'Open Menu',
        pageTitle: 'devices/people',
        tabs: {
          all: 'All',
          offboarding: 'Offboarding',
          offerAccepted: 'Offer Accepted',
          onboarding: 'Onboarding'
        },
        unassignAll: 'Unassign All'
      },
      ruleAndPolicy: pagesDevicesRuleAndPolicyEn,
      settings: {
        actions: {
          copy: 'Copy',
          delete: 'Delete',
          makeActive: 'Make active',
          makeInactive: 'Make inactive',
          openMenu: 'Open menu'
        },
        add: {
          basicInformation: 'Basic Information',
          brand: 'Brand',
          brandPlaceholder: 'select device brand...',
          browseFileButton: 'Browse file',
          category: 'Category',
          categoryPlaceholder: 'Select device category...',
          chooseAnotherFile: 'Choose another file',
          dragYourFileHere: 'Drag your file here!',
          image: 'Image',
          manufacture: 'Manufacture',
          manufacturePlaceholder: 'Select manufacture...',
          name: 'Name',
          namePlaceholder: 'your device name',
          optional: '(Optional)',
          or: 'or',
          registerButton: 'Register',
          successfulMessage: '🎉 Successfully add Catalog!',
          title: 'Add Catalog',
          tryAgain: 'Try again',
          uploadSucceeded: 'Upload succeeded!',
          uploadingWaitAMoment: 'Uploading, wait a moment...!',
          warning: 'If brand has manufacture, value will be auto filled.'
        },
        addCatalogButton: 'Add Catalog',
        assignDeviceDialog: {
          assignmentDate: 'Assignment Date',
          notAssigned: 'Not Assigned',
          selectDatePlaceholder: 'Select date',
          selectInputPlaceholder: 'Select Member',
          title: 'Assign Device',
          unselectedDateErrorMessage: 'Please select a date',
          unselectedMemberErrorMessage: 'Please select a member',
          validFromDate: 'Valid From Date'
        },
        catalog: {
          title: 'Catalog'
        },
        changeDeviceTypeDialog: {
          alertMessage: 'Changing the device type will delete the device type specific data: {{ dataName }} for {{ deviceName}}.',
          cancelButton: 'Cancel',
          deviceDataType: {
            hardwareDisplay: 'Display',
            hardwareInterface: 'Interface',
            hardwareProcessor: 'Processor',
            hardwareStorage: 'Storage',
            software: 'Software'
          },
          editButton: 'Edit',
          saveButton: 'Change device type',
          selectPlaceholder: 'Select device type...',
          title: 'Changing device type'
        },
        decommissionDialog: {
          cancelButton: 'Cancel',
          content: 'Decommission the device.',
          decommissionButton: 'Decommission',
          decommissionDate: 'Decommission Date',
          decommissionReason: 'Reason',
          title: 'Decommission {{name}}?'
        },
        deleteCatalogDialog: {
          cancelButton: 'Cancel',
          content: 'This catalog and all of its data will be deleted. Do you still want to go ahead and delete?',
          permanentlyDeleteButton: 'Permanently Delete',
          title: 'Delete catalog?'
        },
        deviceGroups: pagesDevicesDeviceGroupsEn,
        filterCatalogPlaceholder: 'Filter catalog...',
        filters: {
          active: 'active',
          brand: 'Brand',
          category: 'Category',
          filterOutput: '{{label}} <light>is</light> {{name}}',
          inactive: 'inactive',
          manufacture: 'Manufacture',
          status: 'Status'
        },
        intoMaintenanceDialog: {
          cancelButton: 'Cancel',
          content: 'You can mark the device as under maintenance and unassign it.\nIf recovered, you can assign from under maintenance list.',
          intoMaintenanceButton: 'Save',
          maintenanceReason: 'Reason',
          startMaintenanceDate: 'Maintenance Start Date',
          title: 'Put {{name}} in Maintenance?'
        },
        orderStatusBanner: {
          alreadyReceived: 'Already received this device?',
          checkOrder: 'Check Order',
          steps: {
            inDistribution: 'In distribution',
            ordered: 'Ordered',
            received: 'Received'
          },
          title: 'Your Order is on the way'
        },
        pageTitle: 'devices/settings/catalog',
        recoverMaintenanceDialog: {
          cancelButton: 'Cancel',
          content: 'Recover the device from maintenance status.',
          endMaintenanceDate: 'Maintenance End Date',
          maintenanceReason: 'Reason',
          recoverMaintenanceButton: 'Recover',
          title: 'Recover {{name}} from Maintenance?'
        },
        status: {
          active: 'Active',
          inactive: 'Inactive'
        }
      }
    },
    equipment: pagesEquipmentEn,
    fleets: pagesFleetsEn,
    gaOperationCore: pagesGAOperationCoreEn,
    idManagements: pagesIdManagementsEn,
    itOperationCore: pagesITOperationCoreEn,
    itemLedger: pagesItemLedgerEn,
    laborCore: pagesLaborCoreEn,
    licenses: pagesLicensesEn,
    marketplace: pagesMarketplaceEn,
    me: {
      logoutButton: 'Sign out',
      noOrganizationsMessage: 'No accessible organizations found.\nPlease contact your administrator.',
      reSignInGuidance: "You can't access any organization with your personal email. Please sign in again with your work email or SSO.",
      selectOrganization: 'Select the organization to access',
      switchErrorMessage: 'Failed to switch organization. Please try again.',
      title: 'Welcome'
    },
    networks: pagesNetworksEn,
    notificationAndResponse: pagesNotificationAndResponseEn,
    oauth2: pagesOauth2En,
    operationEvents: pagesOperationEventsEn,
    organization: pagesOrganizationEn,
    payroll: pagesPayrollEn,
    payrollCore: pagesPayrollCoreEn,
    payrollEngine: pagesPayrollEngineEn,
    people: {
      addPerson: 'Add person',
      alumni: {
        filterBarButtons: {
          is: 'is',
          leavingDate: 'Leaving date is within a month',
          within_A_Month: 'within a month'
        }
      },
      cards: {
        goToProfile: 'Go To Profile'
      },
      columns: {
        details: 'Details',
        noApps: 'No software',
        noDevices: 'No devices',
        openMenu: 'Open menu',
        showProfile: 'Show Profile'
      },
      dialogs: {
        addPeople: {
          cancel: 'Cancel',
          email: 'Email',
          firstName: 'First Name',
          job: 'Job',
          joinedOn: 'Joining Date',
          lastName: 'Last Name',
          middleName: 'Middle Name',
          notFound: 'Not Found',
          optional: '(Optional)',
          personCode: 'Person Code',
          save: 'Save',
          searchInputPlaceholder: 'Search people group...',
          selectJobButton: 'Select job...',
          title: 'Adding People'
        }
      },
      megaMenu: {
        contractor: {
          active: 'Active',
          header: 'Contractor',
          joining: {
            header: 'Joining',
            offerAccepted: 'Offer accepted',
            offered: 'Offered'
          },
          leaving: 'Leaving',
          newBies: 'NewBies',
          onLeave: 'On leave'
        },
        employee: {
          active: 'Active',
          all: 'All',
          header: 'Employee',
          joining: {
            header: 'Joining',
            offerAccepted: 'Offer accepted',
            offered: 'Offered'
          },
          leaving: 'Leaving',
          newHire: 'New Hire',
          onLeave: 'On leave'
        }
      },
      operationActivity: pagesPeopleOperationActivityEn,
      overview: {
        cards: {
          departmentCard: {
            title: 'Employee & Contractor',
            unit: 'persons'
          },
          headCountCard: {
            labels: {
              contractor: 'Contractor',
              employee: 'Employee'
            },
            title: 'Headcount Trend'
          },
          leavingCard: {
            title: 'Leaving',
            tooltip: '“Leaving” refers to employees, board members, and contractors, excluding collaborators.',
            unit: 'in {{month}}'
          },
          onboardingCard: {
            title: 'Onboarding',
            tooltip: '“Onboarding” refers to employees, board members, and contractors, excluding collaborators, who have joined the company within one month.',
            unit: 'persons',
            upcoming: 'Upcoming'
          },
          personAvatarHoverCard: {
            link: 'Go to Profile',
            workerType: {
              board_member: 'Board member',
              collaborator: 'Collaborator',
              contractor: 'Contractor',
              employee: 'Employee'
            }
          },
          recentMovementCard: {
            title: 'Recent Employee Movement',
            viewMore: 'View more'
          },
          renewalCard: {
            title: 'Upcoming Renewal',
            unit: 'in {{month}}'
          },
          scheduleCard: {
            events: {
              joining: 'Joining person',
              leaving: 'Leaving person',
              transfer: 'Transfer/Promotion'
            },
            personSuffix: 'persons',
            terms: {
              thisMonth: 'This Month',
              thisWeek: 'This Week',
              today: 'Today'
            },
            title: 'Schedule',
            viewMore: 'View more'
          },
          workerTypeCard: {
            title: 'Workforce',
            type: {
              // TODO: common.workerType に統一したい
              board_member: 'Board member',
              collaborator: 'Collaborator',
              contractor: 'Contractor',
              employee: 'Employee'
            },
            unit: 'persons'
          }
        },
        pageTitle: 'people/overview'
      },
      settings: pagesPeopleSettingsEn,
      title: 'People',
      workforce: {
        addPeople: 'Add People',
        categories: {
          all: {
            active: 'Active',
            joining: 'Joining',
            leaving: 'Leaving',
            newbies: 'Newbies',
            offerAccepted: 'Offer accepted',
            offered: 'Offered',
            title: 'All'
          },
          board: {
            active: 'Active',
            joining: 'Joining',
            leaving: 'Leaving',
            newbies: 'Newbies',
            offerAccepted: 'Offer accepted',
            offered: 'Offered',
            title: 'Board'
          },
          collaborator: {
            active: 'Active',
            title: 'Collaborator'
          },
          contractor: {
            active: 'Active',
            joining: 'Joining',
            leaving: 'Leaving',
            newbies: 'Newbies',
            offerAccepted: 'Offer accepted',
            offered: 'Offered',
            title: 'Contractor'
          },
          employee: {
            active: 'Active',
            comingBackSoon: 'Coming back soon',
            joining: 'Joining',
            leaving: 'Leaving',
            newHire: 'New hire',
            offerAccepted: 'Offer accepted',
            offered: 'Offered',
            onLeave: 'On leave',
            title: 'Employee'
          }
        },
        filterPlaceholder: 'Filter by name...',
        goToProfile: 'Go To Profile',
        importFromGoogle: 'Import from Google Workspace',
        importFromMicrosoft365: 'Import from Microsoft365',
        pageTitle: 'people/list',
        successfulMessage: '🎉 Successfully imported!'
      }
    },
    person: {
      add: {
        form: {
          navigation: {
            item: {
              contractType: 'Contract type',
              fixedTerm: 'Fixed-term employment',
              id: 'ID',
              notApplicable: 'Family register is not applicable',
              permanentTerm: 'Permanent employment',
              selectWorkerTypePlaceholder: {
                board_member: 'Add Board Member to workforce',
                collaborator: 'Add Collaborator to workforce',
                contractor: 'Add Contractor to workforce',
                employee: 'Add Employee to workforce'
              },
              term: {
                board_member: 'Term',
                collaborator: 'Term',
                contractor: 'Term',
                employee: 'Term'
              },
              useCertificateOfResidence: 'Use certificate of residence Description',
              useCurrentAddress: 'Use current address',
              useDifferentAddress: 'Use a different address',
              usePreferredName: 'Use a preferred name',
              useRealName: 'Use real name, {fullName}',
              workerNumber: 'Employee Number'
            },
            step: {
              add: {
                board_member: 'Add Board Member to workforce',
                collaborator: 'Add Collaborator to workforce',
                contractor: 'Add Contractor to workforce',
                employee: 'Add Employee to workforce'
              },
              completed: {
                board_member: 'Added the Board Member data',
                collaborator: 'Added the Collaborator data',
                completedBy: 'Completed by',
                continueAdding: 'Continue adding another person',
                contractor: 'Added the Contractor data',
                employee: 'Added the employee data,',
                goToProfile: 'Go to profile'
              },
              eight: 'Assigned Location',
              five: 'Contact',
              four: {
                board_member: 'Board Member data',
                collaborator: 'Collaborator data',
                contractor: 'Contractor data',
                employee: 'Employee data'
              },
              nine: 'Contract data',
              one: 'Personal data',
              seven: 'Department',
              six: 'Job/Grade',
              ten: 'Payroll',
              three: 'Address',
              two: 'Personal contact'
            },
            subTitle: {
              contract: 'Contract data',
              personal: 'Personal data',
              worker: {
                // TODO: common.workerType に統一したい
                board_member: 'Board Member',
                collaborator: 'Collaborator',
                contractor: 'Contractor',
                employee: 'Employee'
              }
            },
            title: {
              board_member: 'Add Board Member',
              collaborator: 'Add Collaborator',
              contractor: 'Add Contractor',
              employee: 'Add Employee'
            }
          },
          progressbar: {
            filled: 'filled',
            left: '{{value}}left',
            modeSetting: 'Mode Settings',
            mustItem: 'Must Item',
            mustItemOnly: 'Must item only',
            total: 'Total'
          }
        },
        intro: {
          body: {
            fillOutDetails: 'Fill out details',
            itemCard: {
              boardMemberType: 'Board Member type',
              collaboratorType: 'Collaborator type',
              contractTerm: 'Contract term',
              contractorType: 'Contractor type',
              email: 'Email contact',
              employmentType: 'Employment type',
              givenName: 'Given name',
              join: {
                employee: 'Joining date'
              },
              requiredDetails: 'Required details:',
              title: {
                // TODO: common.workerType に統一したい
                board_member: 'Board Member',
                collaborator: 'Collaborator',
                contractor: 'Contractor',
                employee: 'Employee'
              }
            },
            selectMemberType: 'Select the Type:'
          },
          header: {
            description: 'Person data is essential to all features of HR Force and its integration with other Force products. Please ensure that all relevant fields are completed as thoroughly as possible. In DRESS CODE, persons are categorized into the following four types.',
            headerTitle: 'Add person data to your workforce'
          },
          options: {
            automapIngester: {
              button: 'Launch Automap Ingester',
              description: 'Upload resumes and CVs as PDFs in bulk. Automap Ingester extracts names, contacts, work history, and more so you can register many people at once.',
              selectedMemberType: 'Type:',
              title: 'Import resumes / CVs with Automap'
            },
            bulkCsvUpload: {
              button: 'Prepare csv file',
              selectedMemberTypeTitle: {
                // TODO: common.workerType に統一したい
                board_member: 'Board Member',
                collaborator: 'Collaborator',
                contractor: 'Contractor',
                employee: 'Employee'
              },
              title: 'Bulk add by uploading a csv file'
            },
            description: 'Or you might want to...',
            previouslyWorked: 'Select someone who have previously worked for {{value}} ',
            recruitmentCandidates: 'Select someone from the recruitment process',
            syncHR: 'Sync with external HR services'
          }
        }
      },
      addPersonCertification: pagesPersonAddPersonCertificationEn,
      apps: {
        createButton: 'Create',
        deactivateButton: 'Deactivate'
      },
      csvImport: pagesPersonCsvImportEn,
      devices: {
        assignButton: 'Assign device',
        unassignButton: 'Unassign'
      },
      externalHrSaas: pagesPersonExternalHrSaasEn,
      header: {
        dept: 'Dept',
        manager: 'Manager',
        noJobType: '(No job type)',
        noPosition: '(No position)',
        noWorkerType: '(No worker type)',
        tenure: '{{joinedOn}} - {{leftOn}}'
      },
      importCsv: pagesPersonImportCsvEn,
      leaveInfoBanner: {
        changeLeaveDate: 'Change leave date',
        changingLeaveDate: 'Changing leave date',
        leaveEndDate: 'Leave end date',
        leaveStartDate: 'Leave start date',
        leaveType: 'Leave type',
        onLeaveStatus: 'on leave',
        onScheduledLeaveStatus: 'scheduled to leave',
        startOnLeaveOperationPackage: 'Start on leave operation package',
        startReturnToWorkOperationPackage: 'Start return to work operation package'
      },
      personCertification: pagesPersonCertificationEn,
      profile: {
        PersonalSections: {
          PersonalContactSection: {
            AddEmail: {
              addAnotherEmail: 'Add another email contact',
              title: 'Adding contact'
            },
            addEmailLabel: 'Add email',
            deletePhone: {
              description: 'Are you sure you want to remove {{phone}} from the {{personName}}?'
            },
            title: 'Contact'
          },
          PersonalFamilySection: {
            title: 'Family Information',
            viewDialog: {
              groups: {
                address: {
                  columns: {
                    city: 'City',
                    country: 'Country',
                    postalCode: 'Postal Code',
                    residenceType: 'Residence Type',
                    stateProvince: 'State/Province',
                    streetAddress: 'Street Address',
                    streetAddressLine2: 'Building Name/Room Number'
                  },
                  title: 'Address'
                },
                personal: {
                  columns: {
                    bloodType: 'Blood Type',
                    familyName: 'Last Name',
                    familyNameEn: 'Last Name (English)',
                    familyNameKana: 'Last Name (Kana)',
                    gender: 'Gender Identity',
                    givenName: 'First Name',
                    givenNameEn: 'First Name (English)',
                    givenNameKana: 'First Name (Kana)',
                    maidenName: 'Maiden Name',
                    maidenNameEn: 'Maiden Name (English)',
                    maidenNameKana: 'Maiden Name (Kana)',
                    middleName: 'Middle Name',
                    nationality: 'Nationality',
                    nickname: 'Nickname',
                    relationship: 'Relationship',
                    rhType: 'RH Type',
                    sex: 'Sex'
                  },
                  title: 'Personal Information'
                }
              },
              title: 'Profile: {{name}}'
            },
            viewProfile: 'View profile'
          }
        },
        WorkerSections: {
          ContactSection: {
            addEmail: {
              addAnotherEmail: 'Add Another Email',
              title: 'Adding email'
            },
            addExtensionNumber: {
              addAnotherExtensionNumber: 'Add Another Extension Number',
              title: 'Adding extension number'
            },
            addPhone: {
              addAnotherPhone: 'Add Another Phone',
              title: 'Adding phone'
            },
            deleteExtensionNumber: {
              description: 'Are you sure you want to remove {{extensionNumber}} from the {{personName}}?'
            },
            deletePhone: {
              description: 'Are you sure you want to remove {{phone}} from the {{personName}}?'
            },
            subheader: 'Contact'
          },
          DepartmentSection: {
            addDepartment: {
              description: 'If the position is not department-specific, leave the department field blank.',
              title: 'Adding department and/or position'
            },
            addDepartmentLabel: 'Add department and position',
            deleteDepartment: {
              description: "Removing the {{departmentName}} will also remove the {{positionName}} associated with the {{personName}}'s departmental information. Are you sure to want to proceed with this action?",
              descriptionWithoutPosition: 'Are you sure you want to remove {{departmentName}} from the {{personName}}?'
            },
            departments: 'Departments',
            positions: 'Positions',
            searchDepartmentName: 'Search department by name',
            searchPositionName: 'Search position by name',
            selectDepartment: 'Select department',
            selectPosition: 'Select position',
            title: 'Department'
          },
          JobAndGradeSection: {
            Grade: {
              searchGradeName: 'Search grade by name'
            },
            JobCompetency: {
              searchJobCompetencyName: 'Search job competency by name'
            },
            JobFunction: {
              addJobFunction: {
                title: 'Add jobFunction'
              },
              addJobFunctionLabel: 'Add jobFunction',
              deleteJobFunction: {
                description: 'Are you sure you want to remove {{jobFunctionName}} from the {{personName}}?'
              },
              jobFunction: 'jobFunction',
              searchJobFunctionName: 'Search job function by name',
              selectJobFunction: 'Select jobFunction',
              title: 'JobFunction'
            },
            JobGrade: {
              searchJobGradeName: 'Search job grade by name'
            },
            JobLevel: {
              searchJobLevelName: 'Search job level by name'
            },
            JobTitle: {
              searchJobTitleName: 'Search job title by name'
            },
            JobType: {
              addJobType: {
                title: 'Add jobType'
              },
              addJobTypeLabel: 'Add jobType',
              deleteJobType: {
                description: 'Are you sure you want to remove {{jobTypeName}} from the {{personName}}?'
              },
              jobType: 'JobType',
              searchJobTypeName: 'Search jobType by name',
              selectJobType: 'Select jobType',
              title: 'JobType'
            },
            WorkMode: {
              searchWorkModeName: 'Search work mode by name'
            },
            WorkerMode: {
              searchWorkerModeName: 'Search work mode by name'
            }
          },
          PlaceSection: {
            addDepartmentLabel: 'Add assigned location',
            addPlace: {
              title: 'Add assigned location'
            },
            deletePlace: {
              description: 'Are you sure you want to remove {{placeName}} from the {{personName}}?'
            },
            places: 'Assigned Location',
            prcForce: 'PRC Force',
            searchPlaceName: 'Search assigned location by name',
            selectPlace: 'Select assigned location',
            title: 'Assigned Location'
          }
        },
        avatar: {
          editPhoto: 'Edit photo',
          successfulMessage: 'Photo has been changed!',
          upload: {
            error: {
              fileSizeExceeded: 'File size ({{actualSize}}MB) exceeds the maximum allowed size of {{maxSize}}MB.',
              invalidFileType: 'File type "{{mimeType}}" is not supported. Only images (JPEG, PNG) are allowed.',
              unknown: 'File validation failed.'
            }
          }
        },
        department: {
          deleteDialog: {
            button: 'Remove',
            description: 'Are you sure you want to remove {{name}} from {{personName}}?',
            title: 'Removing department'
          },
          primaryTooltip: 'If you want to change the primary department, set another department as primary.',
          trashTooltip: 'Primary department cannot be removed'
        },
        educationsAndQualifications: {
          certification: {
            add: 'Add Held Certification',
            filterPlaceholder: 'Search by certification name or number...'
          },
          tabs: {
            archived: 'Archived',
            certification: 'Certification'
          },
          title: 'Educations and Qualifications'
        },
        employeeInformation: {
          addEmail: 'Add Email',
          addEmployeeSubIdName: 'Add Employee Sub ID',
          addExtensionNumber: 'Add Extension Number',
          addJobFunction: 'Add Job Function',
          addJobType: 'Add Job Type',
          addPhone: 'Add Phone',
          addPlace: 'Add Assigned Location',
          itemCard: {
            accountHolderName: 'Account holder name',
            accountNumber: 'Account number',
            accountType: 'Account type',
            allowanceAmount: 'Allowance Amount',
            allowanceCurrency: 'Currency',
            allowanceTiming: 'Payment Timing',
            annualIncomeForHealthInsuranceUnitYen: 'Annual income (unit: yen)',
            averageTravelTime: 'Average Travel Time',
            bankCode: 'Bank code',
            bankName: 'Bank name',
            basicPensionNumber: 'Basic Pension Number',
            basicPensionNumberImage: 'Basic Pension Number Image',
            basicPensionNumberUnknownReason: 'Reason basic pension number is unknown',
            branchCode: 'Branch code',
            branchName: 'Branch name',
            businessTripEligibility: 'Business Trip Eligibility',
            commuteDistance: 'Commute Distance',
            commutingAllowanceEligibility: 'Commuting Allowance Eligibility',
            contactDetailsAtBank: 'Contact details at bank',
            contractDetailContractor: 'Service Agreement',
            contractDetailEmployee: 'Employment Agreement',
            dailyWorkHours: 'Daily scheduled work hours',
            dateOfDisabilityCertificateIssuance: 'Certificate issuance date',
            // Commute route related
            department: 'Department',
            disabilityCertificateFile: 'Disability certificate file',
            disabilityClassification: 'Disability classification',
            // Transportation fare related
            disabilityGrade: 'Disability grade',
            disabled: 'Disabled person',
            employeeId: 'Employee ID',
            employeePensionInsuranceNumber: 'Employee Pension Insurance Number',
            // Commuting allowance related
            employeeSubId: 'Employee Sub ID',
            employeeSubIdName: 'Employee Sub ID Name',
            employmentEnrollmentDate: 'Employment insurance enrollment date',
            employmentInsuredPersonNumber: "Employment insurance insured person's number",
            employmentInsuredPersonNumberImage: "Employment insurance insured person's number image",
            employmentInsuredPersonNumberUnknownReason: "Reason insured person's number is unknown",
            fareAmount: 'Fare Amount',
            fareCurrency: 'Currency',
            fareType: 'Fare Type',
            fieldWorkEligibility: 'Field Work Eligibility',
            grade: 'Grade',
            headOfHouseholdsName: "Head of household's name",
            headOfHouseholdsRelationship: "Head of household's relationship",
            healthInsuranceEnrollmentDate: 'Health insurance enrollment date',
            healthInsuranceMonthlyCompensation: 'Health insurance monthly compensation (unit: yen) (cash)',
            healthInsuranceMonthlyCompensationInKind: 'Health insurance monthly compensation (unit: yen) (in kind)',
            healthInsuranceReferenceNumber: 'Health insurance reference number',
            icCardUsage: 'IC Card Usage',
            jobCompetency: 'Job Competency',
            jobFunction: 'Job Function',
            jobGrade: 'Job Grade',
            jobLevel: 'Job Level',
            jobTitle: 'Job Title',
            jobType: 'Job Type',
            municipalTaxCode: 'Municipal Tax Code',
            nightShiftStatus: 'Night shift',
            openingDate: 'Opening date',
            overtimeLimit: 'Overtime limit',
            pastCompanyName: 'Past company name',
            pastEmploymentPeriod: 'Past employment period',
            paymentMethodStatus: 'Payment method status',
            pensionEnrollmentDate: 'Pension enrollment date',
            pensionMonthlyCompensation: 'Pension standard monthly remuneration',
            placeEmploymentInsuranceName: 'Employment insurance name',
            placeHealthInsuranceName: 'Health insurance name',
            // Payment Method
            placePensionInsuranceName: 'Pension insurance name',
            placeWorkersCompensationInsuranceName: "Workers' compensation insurance name",
            previousJobTaxStatus: 'Previous job tax status',
            primaryModeOfTransportation: 'Primary Mode of Transportation',
            recipientNumber: 'Recipient number',
            relocationEligibility: 'Relocation Eligibility',
            remoteWorkEligibility: 'Remote Work Eligibility',
            residentStatus: 'Resident Status',
            routeDetail: 'Route Detail',
            singleParent: 'Single parent',
            singleParentDetail: 'Single parent detail',
            // Income Tax
            singleParentReason: 'Single parent reason',
            specialCollectionStartDate: 'Special collection start date',
            transportationFareSection: 'Transportation Fare',
            typeOfDisabilityCertificate: 'Type of disability certificate',
            validityDate: 'Validity date',
            weeklyWorkHours: 'Weekly scheduled work hours',
            widow: 'Widow(er)',
            widowDetail: 'Widow detail',
            widowReason: 'Widow reason',
            withholdingTaxClassification: 'Withholding Tax Classification',
            workLocation: 'Work Location',
            workLocationDetails: 'Work location details',
            workLocationName: 'Actual work site location',
            workMode: 'Work Mode',
            workScheduleType: 'Work Schedule Type',
            workerNumber: 'Employee Number',
            workersCompensationEnrollmentDate: "Workers' compensation enrollment date",
            workingStudent: 'Working student',
            workingStudentDateOfEnrollment: 'Date of enrollment',
            workingStudentEstimatedIncome: 'Estimated income',
            workingStudentSchoolName: 'School name',
            workingStudentStudentIdCardFile: 'Student ID card file',
            workingStudentTypeOfIncome: 'Type of income'
          },
          navigation: {
            subheader: {
              assignmentInfo: 'Employee Assignment Information',
              commutingInformation: 'Commuting Transportation Information',
              compensation: 'Salary & Compensation Information',
              employeeContact: 'Employee Contact',
              employeeIdAndContract: {
                boardMember: 'Employee ID & Board Member',
                collaborator: 'Employee ID & External Collaborator',
                contractor: 'Employee ID & Contractor Contract',
                employee: 'Employee ID & Employment Contract'
              },
              employeePaymentMethod: 'Employee Payment Method',
              socialInsuranceJapan: 'Social Insurance (Japan)',
              taxJapan: {
                incomeTax: 'Income Tax',
                residentTax: 'Resident Tax'
              },
              workProfile: 'Work Information'
            },
            title: 'Employee Information'
          }
        },
        equipment: {
          filterPlaceholder: 'Search equipment...',
          title: 'Equipment'
        },
        itemCard: {
          addAnother: 'Add another',
          addEndDateManually: 'Add end date manually',
          addStreetAddressLine2: 'Add optional address line 2',
          assignedLocations: 'Assigned Location',
          birthPlace: 'Birth Place',
          bloodRhFactor: 'Rh blood factor',
          bloodType: 'Blood type',
          boardMemberType: 'Board Member Type',
          certificateOfResidence: 'Certificate of Residence',
          city: 'City',
          cityPlaceholder: 'Cityville',
          collaboratorType: 'Collaborator Type',
          consecutiveTerm: 'Consecutive term',
          contractDateFrom: 'Start date',
          contractDateTo: 'End date',
          contractorType: 'Contractor Type',
          country: 'Country',
          countryAddress: 'Country address',
          currentAddress: 'Current Address',
          dateOfBirth: {
            age: '{{value}} years old',
            title: 'Date of birth'
          },
          deleteEmail: {
            description: 'Are you sure you want to delete {{email}} from {{personName}}?'
          },
          email: 'Email',
          emergencyContact: 'Emergency Contact',
          emergencyContactAddress: 'Emergency Contact Address',
          employmentType: 'Employment Type',
          empty: '-',
          extensionNumber: 'Extension Number',
          familyAddress: 'Family Address',
          familyName: 'Last or family name',
          familyNameEn: 'Last or family name (English)',
          familyNameKana: 'Last or family name',
          familyRegister: 'Family Register',
          gender: 'Gender',
          givenName: 'First or given name',
          givenNameEn: 'First or given name (English)',
          givenNameKana: 'First or given name',
          grade: 'Grade',
          guarantorAddress: 'Guarantor Address',
          hometown: 'Hometown',
          jobCompetency: 'Job Competency',
          jobFunctions: 'Job Functions',
          jobGrade: 'Job Grade',
          jobLevel: 'Job Level',
          jobTitle: 'Job title',
          jobTypes: 'Job Types',
          maritalStatus: 'Marital status',
          middleName: 'Middle name(s)',
          middleNameEn: 'Middle name(s) (English)',
          middleNameKana: 'Middle name（kana）',
          moveInDate: 'Move in date/Start date',
          moveOutDate: 'End date',
          name: 'Name',
          nationality: 'Nationality',
          otherAddress: 'Other Address',
          permanentAddress: 'Permanent Address',
          phone: 'Phone',
          phoneType: 'Phone type',
          places: 'Places',
          postalCode: 'ZIP / Postal code',
          postalCodePlaceholder: '100-0001',
          prcForce: 'PRC Force',
          preferredName: 'Preferred Name',
          primaryEmail: 'Email (Primary)',
          primaryPhone: 'Primary Phone',
          relationship: 'Relationship',
          religion: 'Religion',
          religionDetail: 'Religion detail',
          residenceType: 'Residence type',
          secondaryEmail: 'Email (Secondary)',
          secondaryPhone: 'Secondary Phone',
          selectAssignedLocation: 'Select Assigned Location',
          selectBloodRhFactor: 'Select Rh blood factor',
          selectBloodType: 'Select Blood type',
          selectEmployeeSubIdName: 'Select employee sub id name',
          selectEndDate: 'Select end date',
          selectGender: 'Select Gender',
          selectGrade: 'Select grade',
          selectJobCompetency: 'Select job competency',
          selectJobFunction: 'Select job function',
          selectJobGrade: 'Select job grade',
          selectJobLevel: 'Select job level',
          selectJobTitle: 'Select job title',
          selectJobType: 'Select job type',
          selectMaritalStatus: 'Select marital status',
          selectNationality: 'Select nationality',
          selectPhoneType: 'Select phone type',
          selectPlace: 'Select Place',
          selectSex: 'Select Sex',
          selectStartDate: 'Select start date',
          selectWorkMode: 'Select work mode',
          sex: 'Sex',
          startDate: 'Start date',
          state: 'State / Province',
          stateProvince: 'State/Province Code',
          streetAddress: 'Street address',
          streetAddressInput: 'Street Address',
          streetAddressInputPlaceholder: '123 Main Street\nApartment 101',
          streetAddressLine2Input: 'Address line 2',
          streetAddressLine2InputPlaceholder: 'Apartment, suite, etc. (optional)',
          term: 'Term',
          undecidedEndDate: 'End date undecided',
          unlimitedTerm: 'Unlimited term',
          unregistered: 'Unregistered',
          workMode: 'Work Mode',
          workerNumber: 'Employee Number',
          zip: 'ZIP / Postal Code'
        },
        jobFunction: {
          deleteDialog: {
            button: 'Remove',
            description: 'Are you sure you want to remove {{name}} from {{personName}}?',
            title: 'Removing job function'
          }
        },
        jobType: {
          deleteDialog: {
            button: 'Remove',
            description: 'Are you sure you want to remove {{name}} from {{personName}}?',
            title: 'Removing job type'
          },
          primaryTooltip: 'If you want to change the primary job type, set another job type as primary.',
          trashTooltip: 'Primary job type cannot be removed'
        },
        navigation: {
          subheader: {
            address: 'Address',
            basic: 'Basic',
            contact: 'Contact',
            contractData: 'Contract data',
            department: 'Department',
            family: 'Family Information',
            familySocialInsuranceAndTaxation: 'Family Social Insurance and Taxation',
            identifiableInformation: 'Identifiable Information',
            jobAndGrade: 'Job and Grade',
            place: 'Place',
            religion: 'Religion',
            snsAndItInformation: 'SNS & IT Information'
          },
          title: {
            board_member: 'Board',
            collaborator: 'Collaborator',
            contract: 'Contract',
            contractor: 'Contractor',
            employee: 'Employee',
            person: 'Personal'
          }
        },
        personalInformation: {
          itemCard: {
            annualIncomeForSocialInsurance: 'Annual income for social insurance',
            basicDailyAllowanceForEmploymentInsurance: 'Basic daily allowance for employment insurance',
            basicPensionNumber: 'Basic Pension Number',
            dateBecameDependentUnderTheTaxLaw: 'Date became dependent under the tax law',
            dateNoLongerDependentUnderTheTaxLaw: 'Date no longer dependent under the tax law',
            dependentStatusUnderTheTaxLaw: 'Dependent status under the tax law',
            documentProvingStudyAbroadFiles: 'Documents proving study abroad',
            documentRelatedToRemittanceFiles: 'Documents related to remittance',
            documentsConfirmingBasicPensionNumberFiles: 'Documents confirming Basic Pension Number',
            emittanceAmountWhenResidingAbroad: 'Remittance amount when residing abroad',
            employmentInsuranceEndDate: 'Employment insurance end date',
            employmentInsuranceReceiptClassification: 'Employment insurance receipt classification',
            employmentInsuranceStartDate: 'Employment insurance start date',
            estimatedAnnualIncomeUnderTheTaxLaw: 'Estimated annual income under the tax law',
            familyCohabitationType: 'Family cohabitation type',
            familyDisability: 'Disability exemption target',
            familyRelationship: 'Family relationship',
            familyRelationshipDocuments: 'Family relationship documents',
            internationalStudent: 'International student',
            monthlyIncomeForSocialInsurance: 'Monthly income for social insurance',
            occupationClassificationOfDependents: 'Occupation classification of dependents',
            reasonBecameDependentForSocialInsurance: 'Reason became dependent for social insurance',
            reasonBecameDependentForTax: 'Reason became dependent for tax',
            reasonNoLongerDependentForSocialInsurance: 'Reason no longer dependent for social insurance',
            reasonNoLongerDependentForTax: 'Reason no longer dependent for tax',
            socialInsuranceBecameDependentDate: 'Date became dependent for social insurance',
            socialInsuranceNoLongerDependentDate: 'Date no longer dependent for social insurance',
            socialInsuranceSupport: 'Social insurance support classification',
            taxSupport: 'Tax support classification'
          }
        },
        place: {
          deleteDialog: {
            button: 'Remove',
            description: 'Are you sure you want to remove {{name}} from {{personName}}?',
            title: 'Removing assigned location'
          },
          primaryTooltip: 'If you want to change the primary assigned location, set another assigned location as primary.',
          trashTooltip: 'Primary assigned location cannot be removed'
        },
        publicId: {
          itemCard: {
            description: 'Residence status detailed description',
            dispatchContractType: 'Dispatch contract type',
            entryDate: 'Entry date',
            issueDate: 'Residence status issue date',
            issuingCountryCode: 'Issuing country code',
            nationalityAndRegion: 'Nationality & Region',
            no: 'No',
            passportName: 'Passport name',
            passportNumber: 'Passport number',
            permissionExtraActivities: 'Permission for extra activities',
            residenceCardFiles: 'Residence card image',
            residenceCardNumber: 'Residence card number',
            residenceStatusName: 'Residence status name',
            validityPeriodFrom: 'Validity period from',
            validityPeriodTo: 'Validity period to',
            visaType: 'Visa type',
            yes: 'Yes'
          },
          navigation: {
            subheader: {
              passport: 'Passport',
              residenceStatus: 'Residence Status',
              workVisa: 'Work Visa'
            },
            title: 'Public ID'
          }
        },
        workExperience: {
          columns: {
            department: 'Department',
            duration: 'Duration',
            employment: 'Employment',
            grade: 'Position',
            period: 'Period',
            summary: 'Summary',
            title: 'Work Experience'
          },
          current: 'Current',
          emptyResult: 'No matching records',
          export: 'Export',
          hideSubItems: 'Hide sub-items',
          periodSeparator: ' – ',
          present: 'Present',
          searchPlaceholder: 'Search title...',
          viewList: 'List',
          viewTimeline: 'Timeline'
        }
      },
      title: 'Person'
    },
    places: pagesPlacesEn,
    prcForce: 'PRC Force',
    profile: {
      app: {
        header: {
          billableUserUnit: ' per user / {{cycle}}',
          contractRenewalCycleMonthly: '{{day}} of each month',
          contractRenewalCycleYearly: 'Every {{month}} {{day}}',
          contractRenewalDate: 'Contract renewal date',
          contractStartedOn: 'Contract started on',
          currencyDisplayFree: 'Free',
          currencyDisplayUnpredictable: 'Pay as you go',
          customApp: 'Custom SaaS',
          cycleText: '{{cycleLength}} {{cycleUnit}}',
          fixedUnit: '/ {{cycle}}',
          in: 'In',
          lastSync: 'Last sync',
          licenseSeatUnit: ' per seat / {{cycle}}',
          plan: 'Plan'
        },
        overview: {
          cards: {
            fromLastMonth: 'from last month',
            monthlyActiveUser: 'Monthly Active User',
            monthlyActiveUserTooltip: 'The percentage of monthly active users is calculated based on whether the user has been active during the current month.',
            monthlyCost: 'Monthly Cost',
            monthlyCostTooltip: 'The monthly cost is determined by the total number of users and the billing plan according to the setting. Please note that actual billing may vary.',
            monthsLeft: '{{value}} left',
            renewsOn: 'Renews On',
            savings: 'Savings',
            savingsTooltip: 'The savings are calculated based on the monthly cost of the users your organization deactivated promptly for security and cost cut purposes.',
            userPeople: 'User (People)',
            userTooltip: "The term 'People' refers to both employees and contractors within the organization, serving as a reference for the 'User'."
          },
          charts: {
            billingAndCost: 'Billing & Cost',
            legend: {
              cumulativeCost: 'Cumulative cost since {{fiscalStartMonth}} ({{scale}})',
              cumulativeUsers: 'Cumulative number of users ({{scale}})',
              forecastedCost: 'Forecasted cost based on scheduled new hires ({{scale}})',
              forecastedCumulativeCost: 'Forecasted cumulative cost based on scheduled new hires ({{scale}})',
              forecastedCumulativeUsers: 'Forecasted cumulative number of users based on scheduled new hires ({{scale}})',
              forecastedUsers: 'Forecasted users on scheduled new hires ({{scale}})',
              monthlyCost: 'Monthly cost ({{scale}})',
              monthlyUsers: 'Number of monthly users ({{scale}})',
              unitUsers: 'users'
            },
            tooltip: {
              costLabel: 'Monthly cost: ',
              cumulativeLabel: 'Cumulative: ',
              userCountLabel: 'User count: '
            },
            userGrowth: 'User Growth'
          },
          recommendedActions: {
            emptyDescription: 'No recommended actions.',
            emptyTitle: 'Looking All Good!',
            importUsers: {
              button: 'Import',
              description: 'Import user data to unlock the full potential of DRESS CODE.',
              title: 'No users yet!'
            },
            title: 'Recommended Actions'
          }
        },
        pageTitle: 'software/integrations/{{name}} - Overview',
        ruleAndPolicy: pagesProfileAppIdRuleAndPolicyEn,
        settings: {
          authentication: {
            authMethod: {
              API_KEY: {
                description: 'Please refer to the {{app_name}}’s website for the appropriate key to use.',
                label: 'API Key'
              },
              ID_PASSWORD: {
                description: 'Use the administrator account to ensure the integration features work correctly.',
                label: 'ID and password'
              },
              NONE: {
                description: 'No authentication required for integration.',
                label: 'No authentication required'
              },
              OAUTH: {
                description: 'OAuth, or open authorization, allows you to authorize DRESS CODE to interact with {{app_name}} on your behalf without revealing your password.',
                label: 'OAuth 2.0'
              }
            },
            edit: 'Edit',
            tenant: 'Tenant / Workspace',
            tenantDescription: 'Tenant / Workspace is a unique identifier for your customer (or company) on the connected Software. If it is not provided by the connected Software, DRESS CODE will assign a random ID.',
            tenantId: 'ID',
            tenantName: 'Name',
            title: 'Authentication',
            update: 'Update',
            updateAuthentication: 'Update Authentication'
          },
          customAppDefinition: {
            appCategoryLabel: 'Software category',
            appLogoLabel: 'Software logo',
            appNameLabel: 'Software Name',
            appUrlLabel: 'Software url',
            description: 'You can manually update the user data.',
            editButton: 'Edit',
            fileSizeError: 'File size must be less than 1MB',
            notSet: 'Not set',
            reloadMessage: 'Avatar changes will take effect after reloading.',
            save: 'Save',
            title: 'Custom SaaS Definition'
          },
          dangerZone: {
            changeAuthDialog: {
              apiKey: 'API Key',
              from: 'From',
              idAndPassword: 'ID and password',
              oauth: 'OAuth 2.0',
              oauthInfo: 'Please use the administrator user account to authenticate.',
              password: 'Password',
              proceedToAuthenticate: 'Proceed to authenticate',
              save: 'Save',
              title: 'Change authentication methods',
              to: 'To'
            },
            changeAuthenticationButton: 'Change the authentication method',
            changeAuthenticationMethod: 'Change authentication method',
            changeAuthenticationMethodDescription: 'Modify the way {{name}} authenticate the DRESS CODE to access the system. Please note that changing authentication methods may cause issues with integration features.',
            deactivateDialog: {
              cancel: 'Cancel',
              deactivateButton: 'Deactivate',
              description: 'Deactivating the integration may affect services that rely on the integration.',
              successfulMessage: '✅ Integration deactivated',
              title: 'Are you sure to deactivate Integration?'
            },
            deactivateIntegration: 'Deactivate integration',
            deactivateIntegrationButton: 'Deactivate this integration',
            deactivateIntegrationDescription: 'Deactivating the integration may affect services that rely on the integration.',
            deleteData: 'Delete Data',
            deleteDataButton: 'Delete all the data',
            deleteDataButtonTooltipContent: 'This operation is possible after the  deactivate integration',
            deleteDataDescription: 'Permanently remove all your data managed by this integration. This action is irreversible.',
            deleteDialog: {
              cancel: 'Cancel',
              deleteButton: 'Permanently Delete',
              description: 'Permanently remove all your data managed by this integration. This action is irreversible.',
              successfulMessage: 'Integration deactivated',
              title: 'Delete data'
            },
            reactivateIntegration: 'Reactivate integration',
            reactivateIntegrationButton: 'Reactivate this integration',
            reactivateIntegrationDescription: 'Reactivating integration may trigger integration features, such as user accounts provisioning.',
            reactiveDialog: {
              cancel: 'Cancel',
              description: 'Reactivating integration may trigger integration features, such as user accounts provisioning.',
              reactivateButton: 'Reactivate',
              successfulMessage: '✅ Integration reactivated',
              title: 'Are you sure to reactivate Integration?'
            },
            title: 'Danger Zone'
          },
          integrationFeatures: {
            autoSyncUserGroups: 'Auto sync user groups',
            description: 'To maximize the benefits of DRESS CODE, it is recommended to enable all integration features.',
            features: {
              NOTIFICATION: 'Notification & Response',
              USER_PROVISIONING: 'User provisioning'
            },
            function: 'Function',
            functions: {
              create: 'Create',
              deactivate: 'Deactivate',
              licenseSwitch: 'License Provisioning',
              notification: 'Notification',
              reactivate: 'Reactivate'
            },
            manualUpdate: {
              description: 'You can manually update the user data.',
              title: 'Manual update'
            },
            requiredReAuthentication: 'Re-authentication is required due to insufficient authentication scopes.',
            singleSignOn: 'Single sign-on',
            title: 'Integration Features',
            tooltip: {
              isNotImplemented: '{{feature}} is not provided for {{appName}}',
              isNotProvidedForPlan: 'This feature is not available in DRESS CODE for your current {{appName}} plan.'
            },
            trainingMode: {
              enabled: 'On',
              readOnlyDescription: 'Training mode was enabled when this integration was installed.',
              title: 'Training mode'
            },
            userListRecipe: {
              authVariable: '{{name}}: {{value}}',
              authVariablesTitle: 'Authentication information',
              authVariablesUnavailable: 'Authentication variables could not be loaded. Reload the page and try again.',
              authenticationUrlLabel: 'Authentication URL',
              cardTitle: 'User list recipe',
              completeInExtension: 'Complete training in the extension before saving the recipe.',
              configureButton: 'Start recipe setup',
              configuredAt: 'Recipe configured: {{date}}',
              configuredAtLabel: 'Configured at',
              delete: {
                confirmDescription: 'The user list will not be updated without a configured recipe.',
                confirmOk: 'Delete recipe',
                confirmTitle: 'Delete the user list recipe?',
                success: 'Recipe deleted.'
              },
              deleteButton: 'Delete recipe',
              description: 'Review and change the recipe configuration.',
              extensionAvailable: 'The extension is installed.',
              extensionChecking: 'Checking the Training Recorder extension...',
              extensionError: 'Failed to communicate with the extension.',
              extensionInstallDescription: 'The Training Recorder extension is not installed. Install it from its public page.',
              extensionInstallLink: 'Install the extension',
              extensionNotFound: 'Training recorder extension not found. Please install it from the Chrome Web Store.',
              extensionPublicPage: 'Open the extension public page',
              extensionStatus: {
                currentCompleted: 'Setting up a recipe for this app - The recipe is complete. Register it.',
                currentInProgress: 'Setting up a recipe for this app - Complete and register the recipe.',
                otherInProgress: 'Setting up a recipe for another app ({{appName}})'
              },
              extensionUnavailable: 'The training extension is not installed.',
              finishSuccess: 'Recipe saved.',
              noAuthVariables: 'No authentication variables are configured.',
              noRecipe: 'No recipe found in the extension. Complete training before trying again.',
              notConfigured: 'Not configured',
              reset: {
                confirmDescription: 'Training is in progress for another app. Reset that progress and continue?',
                confirmOk: 'Reset and continue',
                confirmTitle: 'Reset the current training progress?',
                targetChanged: 'The training target changed while confirmation was open. Review the current progress and try again.'
              },
              saveButton: 'Register completed recipe',
              startSuccess: 'Training context handed to the extension. Perform training on the target app.',
              title: 'Training recipe settings'
            },
            userProvisioning: 'User provisioning'
          },
          mdm: {
            description: 'Configure Mobile Device Management settings for Microsoft Intune integration.',
            labels: {
              clientId: 'Application (client) ID',
              clientSecret: 'Secret ID',
              tenantId: 'Directory (tenant) ID'
            },
            title: 'MDM Configuration',
            toast: {
              updateError: 'Failed to update MDM authentication',
              updateSuccess: 'MDM authentication updated successfully'
            },
            updateAuthentication: 'Update Authentication',
            updateDialog: {
              buttons: {
                updateAuthentication: 'Update Authentication',
                updating: 'Updating...'
              },
              description: 'Enter authentication credentials for Microsoft Intune integration.',
              placeholders: {
                clientId: '1950a258-227b-4e31-a9cf-717495945fc2',
                clientSecret: 'Enter secret ID',
                tenantId: '72f988bf-86f1-41af-91ab-2d7cd011db47'
              },
              title: 'Update MDM Authentication'
            }
          },
          pageTitle: '{{name}} - Settings',
          planDetails: {
            alertContent: 'DRESS CODE is unable to monitor updates to the pricing and billing plans for {{name}}. Please inform us if you make any changes.',
            alertTitle: 'Plan Details needs to be updated manually',
            contractRenewalDate: 'Contract Renewal Date',
            currency: {
              label: 'Currency',
              placeholder: 'Select currency'
            },
            edit: 'Edit',
            licenseSeat: 'License Seat',
            plan: 'Plan',
            planPlaceholder: 'Select plan...',
            save: 'Save',
            saving: 'Saving...',
            subscription: 'Subscription',
            subscriptionPlaceholder: 'Select subscription...',
            title: 'Plan Details',
            useCustomPrice: 'Use custom price'
          },
          pricingBillingPlan: {
            description: 'DRESS CODE is unable to modify the pricing and billing plans for {{name}}. For any changes to your plan or billing details, please visit their pricing page directly.',
            goToAppWebsite: 'Go to the {{name}} website',
            title: 'Pricing/Billing Plan'
          },
          samlSSO: {
            description: 'Security Assertion Markup Language (SAML) and Single Sign-On (SSO) ensure secure and streamlined authentication for your users.',
            disableSSO: 'Disable SSO',
            enableSSO: 'Enable SSO',
            placeholder: 'url to direct users',
            recommend: 'Recommended',
            title: 'SAML / SSO'
          },
          sections: {
            authentication: 'Authentication',
            customAppDefinition: 'Custom SaaS Definition',
            dangerZone: 'Danger Zone',
            integrationFeatures: 'IntegrationFeatures',
            management: 'Management',
            planDetails: 'Plan Details',
            pricingBillingPlan: 'Pricing/Billing Plan',
            samlSso: 'SAML / SSO',
            sso: 'SSO',
            userProvisioning: 'User Provisioning'
          }
        },
        users: {
          action: {
            groupJoin: 'Add to Group',
            groupLeave: 'Remove from Group'
          },
          activeUser: 'Active User',
          alertCategorySidebar: {
            accountState: 'Account Status',
            close: 'Collapse categories',
            open: 'Expand categories',
            title: 'Alert categories'
          },
          changePerson: 'Change Person',
          changePersonDialog: {
            cancelButton: 'Cancel',
            changeAssigneeSuccessfulMessage: 'Assignee has been changed!',
            changePerson: 'Change Person',
            from: 'From',
            noPerson: 'No Person associated',
            saveButton: 'SaveButton',
            selectAssigneePlaceholder: 'Select Assignee',
            to: 'To',
            unassignButton: 'Unassign',
            unassignSuccessfulMessage: 'Assignee has been removed!'
          },
          dialog: {
            groupJoin: {
              description: 'Groups to add',
              title: 'Add to Groups'
            },
            groupLeave: {
              description: 'Groups to remove',
              title: 'Remove from Groups'
            },
            groupProvisioningAllFailed: 'All group changes failed: {{groups}}',
            groupProvisioningPartialError: 'Some group changes failed: {{groups}}',
            groupProvisioningSuccess: 'Group changes completed'
          },
          filterPeoplePlaceholder: 'Filter people...',
          inactiveFor20Days: 'Inactive for 20 days',
          openMenu: 'Open menu',
          pageTitle: 'software/integrations/{{name}} - Users',
          tabs: {
            allUser: 'All user',
            alumni: 'Alumni',
            following: 'Following',
            importUserLabel: 'Import User',
            inactive: 'Inactive',
            noGroup: 'Missing Group',
            noLicense: 'Missing License',
            noUser: 'No User',
            unidentified: 'Unidentified',
            unidentifiedShort: 'Unidentified',
            violatedAccountRole: 'Violated Account Role',
            violatedAssignment: 'Violated Assignment',
            violatedGroup: 'Excess Group',
            violatedLicense: 'Excess License'
          }
        }
      },
      software: {
        header: {
          assignedTotal: 'Assigned / Total',
          renewalDate: 'Renewal date',
          status: 'Status'
        },
        pageTitle: 'software/{{name}} - Overview'
      }
    },
    publicIds: pagesPublicIdsEn,
    settings: {
      permissionAndRoles: pagesSettingsPermissionAndRolesEn,
      persons: pagesSettingsPersonsEn,
      settings: pagesSettingsSettingsEn
    },
    software: pagesSoftwareEn,
    starlinks: pagesStarlinksEn,
    storageFiles: pagesStorageFilesEn,
    supplierLedger: pagesSupplierLedgerEn,
    timeAndAttendance: pagesTimeAndAttendanceEn,
    users: pagesUsersEn,
    vendor: {
      marketplace: pagesVendorMarketplaceEn
    },
    workSchedule: pagesWorkScheduleEn
  }
};
export default en;